import { inject as je, defineComponent as z, computed as P, openBlock as t, createBlock as S, resolveDynamicComponent as he, unref as s, normalizeStyle as oe, normalizeClass as o, ref as M, createElementBlock as n, Fragment as te, renderList as ae, createElementVNode as m, createCommentVNode as u, toDisplayString as x, useSlots as q, renderSlot as $, createTextVNode as Z, pushScopeId as ge, popScopeId as xe, withCtx as O, onMounted as Re, onBeforeUnmount as Je, createVNode as R, mergeProps as de, watch as me, withDirectives as ve, vShow as pe, isRef as ye, vModelText as Ue, withModifiers as N, withKeys as ne, Transition as Ke, vModelDynamic as Xe, toRef as Qe, vModelCheckbox as Ee, reactive as Ye, nextTick as _e, watchEffect as el, toRefs as ll } from "vue";
const Ie = typeof window < "u", Ge = (e) => e.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (i, l) => (l ? "-" : "") + i.toLowerCase()), He = Symbol.for("torusui:icons"), Ks = (e) => `${Ge(e)}`, Gs = (e) => ({ install: (l) => {
  const d = () => {
    const r = {};
    return Object.entries(e || {}).forEach(([c, b]) => {
      r[Ge(c)] = b;
    }), r;
  }, { mount: a } = l;
  l.mount = (r, c, b) => {
    l.provide(He, d());
    const f = a(r, c, b);
    return l.mount = a, f;
  };
} }), tl = (e) => {
  const i = je(He);
  if (!i)
    throw new Error(`Missing Torus Icons provided ${e}`);
  return i[e] ? i[e] : (console.error(`Missing Icon name give ${e}`), null);
}, V = /* @__PURE__ */ z({
  __name: "Icon",
  props: {
    name: null,
    size: { default: "20" },
    class: { default: "" }
  },
  setup(e) {
    const i = e, l = P(() => typeof i.class == "string" ? [i.class, "w-5"] : [i.class, "w-5"].join(" ")), d = P(() => tl(i.name));
    return (a, r) => (t(), S(he(s(d)), {
      style: oe({ width: i.size, height: i.size }),
      class: o(s(l))
    }, null, 8, ["style", "class"]));
  }
}), al = ["data-accordion-target", "aria-expanded", "aria-controls", "aria-label", "onClick"], sl = {
  class: /* @__PURE__ */ o(["flex-1"])
}, nl = ["aria-labelledby", "aria-expanded", "aria-controls"], ol = /* @__PURE__ */ z({
  __name: "Accordion",
  props: {
    accordionItems: null,
    activeIndex: { default: -1 },
    activeIndexes: { default: () => [] },
    alternateOpen: { type: Boolean, default: !1 },
    flushAccordion: { type: Boolean, default: !1 },
    rounded: { type: Boolean, default: !0 },
    arrowUpIcon: { default: "chevron-up-solid-icon" },
    arrowDownIcon: { default: "chevron-down-solid-icon" },
    showHeadingIcon: { type: Boolean, default: !1 },
    showArrowIcon: { type: Boolean, default: !0 },
    classes: { default: () => ({}) }
  },
  setup(e) {
    const i = e, l = M(i.activeIndex > -1 ? i.activeIndex : -1), d = M(i.activeIndexes || []), a = (r) => {
      i.alternateOpen ? d.value = d.value.includes(r) ? d.value.filter((c) => c !== r) : [...d.value, r] : l.value = l.value === r ? -1 : r;
    };
    return (r, c) => {
      var b;
      return t(), n("div", {
        "data-accordion": "collapse",
        class: o([(b = e.classes) == null ? void 0 : b.container])
      }, [
        (t(!0), n(te, null, ae(e.accordionItems, (f, v) => {
          var y, h, k, C, g, p, I, T, D, w, E, j;
          return t(), n("div", {
            key: f.heading
          }, [
            m("h2", {
              class: o([(y = e.classes) == null ? void 0 : y.headingContainer])
            }, [
              m("button", {
                type: "button",
                class: o([
                  "accordion-heading",
                  (e.alternateOpen ? (h = d.value) == null ? void 0 : h.includes(v) : l.value === v) && (((k = e.classes) == null ? void 0 : k.activeAccordion) || "accordion-active"),
                  {
                    "rounded-t-lg": v === 0,
                    "border-b": v === e.accordionItems.length - 1 && !(e.alternateOpen ? (C = d.value) != null && C.includes(v) : l.value === v),
                    "!rounded-none": !e.rounded
                  },
                  e.flushAccordion && (((g = e.classes) == null ? void 0 : g.flushAccordion) || "accordion-flushed")
                ]),
                "data-accordion-target": `accordion-collapse-body-${v}`,
                "aria-expanded": e.alternateOpen ? (p = d.value) == null ? void 0 : p.includes(v) : l.value === v,
                "aria-controls": `accordion-collapse-body-${v}`,
                "aria-label": f.heading || `label-${v}`,
                onClick: (H) => a(v)
              }, [
                f != null && f.headingIcon && e.showHeadingIcon ? (t(), S(s(V), {
                  key: 0,
                  name: f == null ? void 0 : f.headingIcon,
                  class: o(["accordion-heading-icon", "flex-none", ((I = e.classes) == null ? void 0 : I.headingIcon) || ""])
                }, null, 8, ["name", "class"])) : u("", !0),
                m("span", sl, x(f.heading), 1),
                e.showArrowIcon ? (t(), S(s(V), {
                  key: 1,
                  name: e.alternateOpen ? (T = d.value) != null && T.includes(v) ? e.arrowUpIcon : e.arrowDownIcon : l.value === v ? e.arrowUpIcon : e.arrowDownIcon,
                  class: o(["mt-2", ((D = e.classes) == null ? void 0 : D.arrowIcon) || ""])
                }, null, 8, ["name", "class"])) : u("", !0)
              ], 10, al)
            ], 2),
            m("div", {
              class: o([!(e.alternateOpen ? (w = d.value) != null && w.includes(v) : l.value === v) && "hidden"]),
              "aria-labelledby": `accordion-collapse-heading-${v}`,
              "aria-expanded": l.value === v,
              "aria-controls": `accordion-collapse-body-${v}`
            }, [
              m("div", {
                class: o([
                  "accordion-body",
                  { "rounded-b-lg border-b": v === e.accordionItems.length - 1 },
                  e.flushAccordion && (((E = e.classes) == null ? void 0 : E.flushAccordion) || "accordion-flushed"),
                  (j = e.classes) == null ? void 0 : j.bodyContainer
                ])
              }, x(f.body), 3)
            ], 10, nl)
          ]);
        }), 128))
      ], 2);
    };
  }
});
const A = (e, i) => {
  const l = e.__vccOpts || e;
  for (const [d, a] of i)
    l[d] = a;
  return l;
}, Hs = /* @__PURE__ */ A(ol, [["__scopeId", "data-v-7c2ef757"]]), dl = (e) => (ge("data-v-f848d640"), e = e(), xe(), e), il = ["id"], cl = { key: 0 }, ul = /* @__PURE__ */ dl(() => /* @__PURE__ */ m("span", { class: "sr-only" }, "Close", -1)), rl = /* @__PURE__ */ z({
  __name: "Alerts",
  props: {
    variant: { default: "default" },
    heading: { default: "" },
    message: { default: "" },
    showClearIcon: { type: Boolean, default: !1 },
    ctaButton: { default: () => ({ primary: { name: "" }, secondary: { name: "" } }) },
    id: { default: "" },
    inlineMessage: { type: Boolean, default: !1 },
    showIcon: { type: Boolean, default: !1 },
    classes: { default: () => ({}) },
    clearIcon: { default: "x-solid-icon" },
    alertIcon: { default: "exclamation-circle-solid-icon" },
    ctaPrimaryIcon: { default: "eye-solid-icon" }
  },
  emits: ["onClear", "onPrimaryBtnClick", "onSecondaryBtnClick"],
  setup(e, { emit: i }) {
    const l = q();
    return (d, a) => {
      var r, c, b, f, v, y, h, k, C, g, p, I, T, D, w, E, j, H, J, U, W, Q, _, K, X, ue, ie, ce, se, re, we, $e, ke, B;
      return t(), n("div", {
        id: e.id,
        class: o([`alert-${e.variant}`, (r = e.classes) == null ? void 0 : r.container]),
        role: "alert"
      }, [
        m("div", {
          class: o(["flex items-center", (c = e.classes) == null ? void 0 : c.inlineMsgContainer])
        }, [
          e.showIcon ? (t(), n("span", cl, [
            (b = s(l)) != null && b.alertIcon ? (f = s(l)) != null && f.alertIcon ? $(d.$slots, "alertIcon", { key: 1 }, void 0, !0) : u("", !0) : (t(), S(s(V), {
              key: 0,
              name: e.alertIcon,
              class: "mr-2 w-5",
              size: "20"
            }, null, 8, ["name"]))
          ])) : u("", !0),
          (v = s(l)) != null && v.alertHeading ? u("", !0) : (t(), n("h3", {
            key: 1,
            class: o(["text-lg font-medium", (y = e.classes) == null ? void 0 : y.heading])
          }, x(e.heading), 3)),
          (h = s(l)) != null && h.alertHeading ? $(d.$slots, "alertHeading", { key: 2 }, void 0, !0) : u("", !0),
          !((k = s(l)) != null && k.alertMessage) && e.message && (e.inlineMessage || !e.heading) ? (t(), n("span", {
            key: 3,
            class: o(["text-sm", e.heading && "pl-2 pt-1", (C = e.classes) == null ? void 0 : C.message])
          }, x(e.message), 3)) : u("", !0),
          (g = s(l)) != null && g.alertMessage && (e.inlineMessage || !e.heading) ? $(d.$slots, "alertMessage", { key: 4 }, void 0, !0) : u("", !0),
          e.showClearIcon ? (t(), n("button", {
            key: 5,
            type: "button",
            class: o(["ml-auto -mx-1.5 bg-transparent inline-flex", (p = e.classes) == null ? void 0 : p.clearIcon]),
            "data-dismiss-target": "#alert-1",
            "aria-label": "Close",
            onClick: a[0] || (a[0] = (L) => i("onClear"))
          }, [
            ul,
            (I = s(l)) != null && I.dismissableIcon ? (T = s(l)) != null && T.dismissableIcon ? $(d.$slots, "dismissableIcon", { key: 1 }, void 0, !0) : u("", !0) : (t(), S(s(V), {
              key: 0,
              name: e.clearIcon
            }, null, 8, ["name"]))
          ], 2)) : u("", !0)
        ], 2),
        !((D = s(l)) != null && D.alertMessage) && e.message && !e.inlineMessage && e.heading ? (t(), n("div", {
          key: 0,
          class: o([e.heading && "mt-2", "text-sm font-normal", (((E = (w = e.ctaButton) == null ? void 0 : w.primary) == null ? void 0 : E.name) || ((H = (j = e.ctaButton) == null ? void 0 : j.secondary) == null ? void 0 : H.name)) && "mb-4", (J = e.classes) == null ? void 0 : J.message])
        }, x(e.message), 3)) : u("", !0),
        (U = s(l)) != null && U.alertMessage && !e.inlineMessage && e.heading ? $(d.$slots, "alertMessage", { key: 1 }, void 0, !0) : u("", !0),
        (Q = (W = e.ctaButton) == null ? void 0 : W.primary) != null && Q.name || (K = (_ = e.ctaButton) == null ? void 0 : _.secondary) != null && K.name ? (t(), n("div", {
          key: 2,
          class: o(["flex", e.inlineMessage && "mt-4", (X = e.classes) == null ? void 0 : X.ctaBtnContainer])
        }, [
          (ue = e.ctaButton.primary) != null && ue.name ? (t(), n("button", {
            key: 0,
            type: "button",
            class: o([`alert-cta-primary-${e.variant}`, (ie = e.classes) == null ? void 0 : ie.ctaPrimaryBtn]),
            onClick: a[1] || (a[1] = (L) => i("onPrimaryBtnClick"))
          }, [
            (ce = s(l)) != null && ce.ctaPrimaryIcon ? (re = s(l)) != null && re.ctaPrimaryIcon ? $(d.$slots, "ctaPrimaryIcon", { key: 1 }, void 0, !0) : u("", !0) : (t(), S(s(V), {
              key: 0,
              name: e.ctaPrimaryIcon,
              class: o(["mr-2 w-5", ((se = e.classes) == null ? void 0 : se.ctaPrimaryBtnIcon) || ""]),
              size: "20"
            }, null, 8, ["name", "class"])),
            Z(" " + x((we = e.ctaButton.primary) == null ? void 0 : we.name), 1)
          ], 2)) : u("", !0),
          ($e = e.ctaButton.secondary) != null && $e.name ? (t(), n("button", {
            key: 1,
            type: "button",
            class: o([`alert-cta-secondary-${e.variant}`, (ke = e.classes) == null ? void 0 : ke.ctaSecondaryBtn]),
            "data-dismiss-target": "#`${id}`",
            "aria-label": "Close",
            onClick: a[2] || (a[2] = (L) => i("onSecondaryBtnClick"))
          }, x((B = e.ctaButton.secondary) == null ? void 0 : B.name), 3)) : u("", !0)
        ], 2)) : u("", !0)
      ], 10, il);
    };
  }
});
const Ws = /* @__PURE__ */ A(rl, [["__scopeId", "data-v-f848d640"]]), fl = ["id"], vl = /* @__PURE__ */ z({
  __name: "Avatar",
  props: {
    id: { default: "" },
    size: { default: "md" },
    rounded: { type: Boolean, default: !0 },
    border: { type: Boolean, default: !1 },
    classes: { default: () => ({}) }
  },
  emits: ["onClick"],
  setup(e, { emit: i }) {
    const l = e, d = P(() => l.size === "xs" ? "w-6 h-6" : l.size === "sm" ? "w-8 h-8" : l.size === "md" ? "w-10 h-10" : l.size === "lg" ? "w-14 h-14" : "w-20 h-20");
    return (a, r) => {
      var c;
      return t(), n("div", {
        id: e.id,
        role: "button",
        class: o(["avatar-container", s(d), { "rounded-full": e.rounded, "rounded-lg": !e.rounded, "avatar-border": e.border }, (c = e.classes) == null ? void 0 : c.container]),
        "aria-hidden": "",
        onClick: r[0] || (r[0] = (b) => i("onClick"))
      }, [
        $(a.$slots, "default", {}, void 0, !0)
      ], 10, fl);
    };
  }
});
const Zs = /* @__PURE__ */ A(vl, [["__scopeId", "data-v-4ceda21c"]]), bl = (e) => (ge("data-v-324b9d24"), e = e(), xe(), e), ml = ["data-dismiss-target"], yl = /* @__PURE__ */ bl(() => /* @__PURE__ */ m("span", { class: "sr-only" }, "Remove badge", -1)), hl = /* @__PURE__ */ z({
  __name: "Badge",
  props: {
    size: { default: "small" },
    variant: { default: "default" },
    pill: { type: Boolean, default: !1 },
    border: { type: Boolean, default: !1 },
    clearIcon: { type: Boolean, default: !1 },
    id: { default: "" },
    classes: { default: () => ({}) },
    component: { default: "span" }
  },
  emits: ["onClear"],
  setup(e, { emit: i }) {
    const l = e, d = q(), a = P(() => l.component);
    return (r, c) => {
      var b;
      return t(), S(he(s(a)), {
        id: e.id,
        class: o([
          "badge",
          `badge-${e.size}`,
          `badge-${e.variant}`,
          `rounded-${e.pill ? "full" : "md"}`,
          e.border && `badge-${e.variant}-border`,
          (b = e.classes) == null ? void 0 : b.container
        ]),
        role: "status"
      }, {
        default: O(() => {
          var f, v, y;
          return [
            $(r.$slots, "default", {}, void 0, !0),
            e.clearIcon ? (t(), n("button", {
              key: 0,
              type: "button",
              class: o(["inline-flex items-center p-0.5 ml-2 text-sm bg-transparent rounded-sm", (f = e.classes) == null ? void 0 : f.clearIcon]),
              "data-dismiss-target": `#${e.id || `badge-dismiss-${e.variant}`}`,
              "aria-label": "Remove",
              onClick: c[0] || (c[0] = (h) => i("onClear"))
            }, [
              (v = s(d)) != null && v.dismissibleIcon ? u("", !0) : (t(), S(s(V), {
                key: 0,
                name: "x-solid-icon",
                size: "15",
                class: "w-[15px]"
              })),
              yl,
              (y = s(d)) != null && y.dismissibleIcon ? $(r.$slots, "dismissibleIcon", { key: 1 }, void 0, !0) : u("", !0)
            ], 10, ml)) : u("", !0)
          ];
        }),
        _: 3
      }, 8, ["id", "class"]);
    };
  }
});
const gl = /* @__PURE__ */ A(hl, [["__scopeId", "data-v-324b9d24"]]), xl = {
  key: 0,
  class: "loader"
}, kl = /* @__PURE__ */ z({
  __name: "Button",
  props: {
    size: { default: "md" },
    variant: { default: "primary" },
    block: { type: Boolean, default: !1 },
    type: { default: "button" },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    pill: { type: Boolean, default: !1 },
    rounded: { type: Boolean, default: !1 },
    classes: { default: () => ({}) },
    component: { default: "button" },
    href: { default: "" }
  },
  emits: ["onClick"],
  setup(e, { emit: i }) {
    const l = e, d = P(() => {
      var b;
      let r = "";
      const c = ["font-body"];
      return l.variant === "text" ? c.push("text-xs") : l.rounded ? (r = `icon-${l.size}`, c.push("icon")) : r = `size-${l.size}`, [
        ...c,
        r,
        "t-btn",
        `t-btn-${l.variant}`,
        `rounded-${l.pill ? "full" : "md"}`,
        { block: !l.rounded && l.block, loading: l.loading, "cursor-not-allowed": l.disabled, "btn-link": l.href },
        ((b = l.classes) == null ? void 0 : b.container) || ""
      ];
    }), a = P(() => l.href ? "a" : l.component || "div");
    return (r, c) => (t(), S(he(s(a)), {
      href: e.href || "",
      class: o(s(d)),
      type: e.type,
      disabled: e.loading || e.disabled,
      role: e.href ? "link" : "button",
      onClick: c[0] || (c[0] = (b) => !(e.loading || e.disabled) && i("onClick"))
    }, {
      default: O(() => [
        e.loading ? (t(), n("div", xl)) : u("", !0),
        $(r.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["href", "class", "type", "disabled", "role"]));
  }
});
const le = /* @__PURE__ */ A(kl, [["__scopeId", "data-v-bd2e0fef"]]), wl = /* @__PURE__ */ z({
  __name: "Breadcrumb",
  props: {
    variant: { default: "default" },
    items: null,
    divider: { default: "" },
    dividerIcon: { default: "chevron-right-solid-icon" },
    prependIcon: { default: "home-solid-icon" },
    classes: { default: () => ({}) }
  },
  emits: ["onItemClick"],
  setup(e, { emit: i }) {
    const l = q();
    return (d, a) => {
      var r;
      return t(), n("nav", {
        class: o(["breadcrumb-nav", e.variant === "solid" && "breadcrumb-solid", (r = e.classes) == null ? void 0 : r.container]),
        "aria-label": "Breadcrumb"
      }, [
        (t(!0), n(te, null, ae(e.items, (c, b) => {
          var f, v, y, h, k, C, g;
          return t(), n("ol", {
            key: c.name,
            class: o(["inline-flex items-center space-x-1 md:space-x-3", (f = e.classes) == null ? void 0 : f.listContainer])
          }, [
            m("li", {
              class: o(["inline-flex items-center", (v = e.classes) == null ? void 0 : v.itemContainer])
            }, [
              b !== 0 && !e.divider && !s(l).customDivider ? (t(), S(s(V), {
                key: 0,
                name: e.dividerIcon,
                class: o(["mx-5 md:mx-3", ((y = e.classes) == null ? void 0 : y.dividerIcon) || ""])
              }, null, 8, ["name", "class"])) : u("", !0),
              b !== 0 && e.divider && !s(l).customDivider ? (t(), n("span", {
                key: 1,
                class: o(["breadcrumb-divider", (h = e.classes) == null ? void 0 : h.divider])
              }, x(e.divider), 3)) : u("", !0),
              b !== 0 && !e.divider && s(l).customDivider ? (t(), n("span", {
                key: 2,
                class: o(["breadcrumb-divider", (k = e.classes) == null ? void 0 : k.divider])
              }, [
                $(d.$slots, "customDivider", {}, void 0, !0)
              ], 2)) : u("", !0),
              b !== e.items.length - 1 && !c.disable ? (t(), S(s(le), {
                key: 3,
                class: o(["breadcrumb-link", (C = e.classes) == null ? void 0 : C.linkItem]),
                disabled: c.disable,
                variant: "text",
                onOnClick: (p) => i("onItemClick", c)
              }, {
                default: O(() => {
                  var p, I;
                  return [
                    b === 0 && !s(l).prepend ? (t(), S(s(V), {
                      key: 0,
                      name: e.prependIcon,
                      class: o(["mr-4 w-[17px] md:mr-2", ((p = e.classes) == null ? void 0 : p.prependIcon) || ""]),
                      size: "17"
                    }, null, 8, ["name", "class"])) : u("", !0),
                    b === 0 && s(l).prepend ? (t(), n("span", {
                      key: 1,
                      class: o(["mr-4 md:mr-2", (I = e.classes) == null ? void 0 : I.prepend])
                    }, [
                      $(d.$slots, "prepend", {}, void 0, !0)
                    ], 2)) : u("", !0),
                    Z(" " + x(c.name), 1)
                  ];
                }),
                _: 2
              }, 1032, ["class", "disabled", "onOnClick"])) : (t(), n("span", {
                key: 4,
                class: o(["breadcrumb-span", (g = e.classes) == null ? void 0 : g.staticItem])
              }, x(c.name), 3))
            ], 2)
          ], 2);
        }), 128))
      ], 2);
    };
  }
});
const qs = /* @__PURE__ */ A(wl, [["__scopeId", "data-v-c62bdb61"]]), $l = {
  key: 0,
  class: "footer"
}, pl = /* @__PURE__ */ z({
  __name: "Card",
  props: {
    height: { default: "inherit" },
    border: { type: Boolean, default: !0 },
    rounded: { type: Boolean, default: !0 },
    shadow: { type: Boolean, default: !0 },
    classes: { default: () => ({}) }
  },
  setup(e) {
    const i = e, l = q(), d = P(() => {
      var r;
      return ["card-container", { "!border-0": !i.border, "!rounded-none": !i.rounded, "!shadow-none": !i.shadow }, (r = i.classes) == null ? void 0 : r.container];
    }), a = P(() => l.footer);
    return (r, c) => (t(), n("div", {
      class: o(s(d)),
      style: oe({ height: e.height })
    }, [
      $(r.$slots, "default", {}, void 0, !0),
      s(a) ? (t(), n("div", $l, [
        $(r.$slots, "footer", {}, void 0, !0)
      ])) : u("", !0)
    ], 6));
  }
});
const Js = /* @__PURE__ */ A(pl, [["__scopeId", "data-v-a59ccc29"]]), Cl = ["src", "alt"], Il = /* @__PURE__ */ z({
  __name: "CarouselItem",
  props: {
    src: { default: "" },
    alt: { default: "" },
    classes: { default: () => ({}) }
  },
  setup(e) {
    const i = q();
    return (l, d) => {
      var a, r, c;
      return t(), n("div", {
        class: o(["duration-1000 ease-out w-full h-full delay-75", (a = e.classes) == null ? void 0 : a.container]),
        "data-carousel-item": ""
      }, [
        !s(i).item && e.src ? (t(), n("img", {
          key: 0,
          src: e.src,
          class: o(["absolute block img-container -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2", (r = e.classes) == null ? void 0 : r.img]),
          alt: e.alt || "carousel-item"
        }, null, 10, Cl)) : u("", !0),
        s(i).item ? (t(), n("div", {
          key: 1,
          class: o(["absolute block w-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2", (c = e.classes) == null ? void 0 : c.slot])
        }, [
          $(l.$slots, "item", {}, void 0, !0)
        ], 2)) : u("", !0)
      ], 2);
    };
  }
});
const Bl = /* @__PURE__ */ A(Il, [["__scopeId", "data-v-6826a57e"]]), Tl = ["id"], Ll = ["aria-current", "aria-label", "data-carousel-slide-to", "onClick"], Sl = {
  key: 0,
  class: "inline-flex items-center justify-center w-8 h-8 rounded-full sm:w-10 sm:h-10 text-app-white bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none"
}, zl = /* @__PURE__ */ m("span", { class: "sr-only" }, "Previous", -1), Pl = { key: 1 }, Dl = {
  key: 0,
  class: "inline-flex items-center justify-center w-8 h-8 rounded-full sm:w-10 sm:h-10 text-app-white bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none"
}, Vl = /* @__PURE__ */ m("span", { class: "sr-only" }, "Next", -1), Al = { key: 1 }, Xs = /* @__PURE__ */ z({
  __name: "Carousel",
  props: {
    type: { default: "default" },
    items: { default: () => [] },
    showIndicators: { type: Boolean, default: !0 },
    showPrevBtn: { type: Boolean, default: !0 },
    showNextBtn: { type: Boolean, default: !0 },
    previousIcon: { default: "chevron-left-icon" },
    nextIcon: { default: "chevron-right-icon" },
    classes: { default: () => ({}) },
    timeInterval: { default: 3e3 },
    id: { default: "" }
  },
  emits: ["onPrev", "onNext", "onIndicatorClick"],
  setup(e, { emit: i }) {
    const l = e, d = q(), a = M(void 0), r = P(() => {
      var h, k;
      return d != null && d.carouselItems ? d == null ? void 0 : d.carouselItems.length : l != null && l.items && ((h = l == null ? void 0 : l.items) == null ? void 0 : h.length) > 0 ? (k = l.items) == null ? void 0 : k.length : 0;
    }), c = M(0), b = () => {
      c.value = c.value === 0 ? r.value - 1 : c.value - 1, i("onPrev");
    }, f = () => {
      c.value = c.value === r.value - 1 ? 0 : c.value + 1, i("onNext");
    }, v = (h) => {
      c.value = h, i("onIndicatorClick", h);
    }, y = () => {
      a.value = setInterval(() => {
        c.value = c.value === r.value - 1 ? 0 : c.value + 1;
      }, l.timeInterval);
    };
    return Re(() => {
      l.type === "timed" && y();
    }), Je(() => {
      clearInterval(a.value);
    }), (h, k) => {
      var C, g, p, I, T, D, w, E, j, H, J, U, W, Q, _;
      return t(), n("div", {
        id: e.id,
        class: o(["relative", (C = e.classes) == null ? void 0 : C.container]),
        "data-carousel": "static"
      }, [
        !((g = s(d)) != null && g.carouselItems) && e.items && e.items.length > 0 ? (t(), n("div", {
          key: 0,
          class: o(["relative h-56 overflow-hidden rounded-lg md:h-96", (p = e.classes) == null ? void 0 : p.wrapper])
        }, [
          (t(!0), n(te, null, ae(e.items, (K, X) => (t(), n("span", {
            key: K.src,
            class: "w-full h-full"
          }, [
            c.value === X ? (t(), S(s(Bl), {
              key: 0,
              src: K.src,
              alt: K.alt || `item-${X}`,
              classes: K == null ? void 0 : K.classes
            }, null, 8, ["src", "alt", "classes"])) : u("", !0)
          ]))), 128)),
          (I = s(d)) != null && I.carouselItems ? $(h.$slots, "carouselItems", { key: 0 }) : u("", !0)
        ], 2)) : u("", !0),
        e.showIndicators ? (t(), n("div", {
          key: 1,
          class: o(["absolute z-30 flex space-x-3 -translate-x-1/2 bottom-5 left-1/2", (T = e.classes) == null ? void 0 : T.indicator])
        }, [
          (D = s(d)) != null && D.indicators ? u("", !0) : (t(!0), n(te, { key: 0 }, ae(Array.from({ length: s(r) }, (K, X) => X), (K, X) => (t(), n("button", {
            key: X,
            type: "button",
            class: o(["w-3 h-3 rounded-full", c.value === X ? "bg-app-white" : "bg-app-gray-400"]),
            "aria-current": c.value === X,
            "aria-label": `Slide ${X}`,
            "data-carousel-slide-to": X,
            onClick: (ue) => v(X)
          }, null, 10, Ll))), 128)),
          (w = s(d)) != null && w.indicators ? $(h.$slots, "indicators", { key: 1 }) : u("", !0)
        ], 2)) : u("", !0),
        e.showPrevBtn ? (t(), n("button", {
          key: 2,
          type: "button",
          class: o(["absolute top-0 left-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none", (E = e.classes) == null ? void 0 : E.prevBtn]),
          "data-carousel-prev": "",
          onClick: b
        }, [
          (j = s(d)) != null && j.previous ? u("", !0) : (t(), n("span", Sl, [
            R(s(V), {
              name: e.previousIcon,
              size: "24",
              class: o(["w-6", ((H = e.classes) == null ? void 0 : H.prevIcon) || ""])
            }, null, 8, ["name", "class"]),
            zl
          ])),
          (J = s(d)) != null && J.previous ? (t(), n("span", Pl, [
            $(h.$slots, "previous")
          ])) : u("", !0)
        ], 2)) : u("", !0),
        e.showNextBtn ? (t(), n("button", {
          key: 3,
          type: "button",
          class: o(["absolute top-0 right-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none", (U = e.classes) == null ? void 0 : U.nextBtn]),
          "data-carousel-next": "",
          onClick: f
        }, [
          (W = s(d)) != null && W.next ? u("", !0) : (t(), n("span", Dl, [
            R(s(V), {
              name: e.nextIcon,
              size: "24",
              class: o(["w-6", ((Q = e.classes) == null ? void 0 : Q.nextIcon) || ""])
            }, null, 8, ["name", "class"]),
            Vl
          ])),
          (_ = s(d)) != null && _.next ? (t(), n("span", Al, [
            $(h.$slots, "next")
          ])) : u("", !0)
        ], 2)) : u("", !0)
      ], 10, Tl);
    };
  }
}), Ml = ["id", "aria-checked", "aria-labelledby", "checked", "value", "disabled"], Fl = ["for"], El = {
  key: 0,
  class: "text-xs text-app-gray-500 dark:text-app-gray-400"
}, Nl = ["for"], Ol = /* @__PURE__ */ z({
  __name: "Checkbox",
  props: {
    label: { default: "" },
    description: { default: "" },
    value: { default: "" },
    id: { default: "" },
    checked: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    rounded: { type: Boolean },
    labelPlacement: { default: "right" },
    classes: { default: () => ({}) }
  },
  emits: ["onChange", "update:checked"],
  setup(e, { emit: i }) {
    const l = q(), d = (a) => {
      var b, f;
      const r = (b = a == null ? void 0 : a.target) == null ? void 0 : b.checked, c = (f = a == null ? void 0 : a.target) == null ? void 0 : f.value;
      i("onChange", r, c, a), i("update:checked", r);
    };
    return (a, r) => {
      var c, b, f, v, y, h;
      return t(), n("div", {
        class: o(["flex items-center w-fit gap-2", `checkbox-label-${e.labelPlacement}`, a.$attrs.class, (c = e.classes) == null ? void 0 : c.container])
      }, [
        m("input", de({
          id: e.id,
          "aria-checked": e.checked,
          "aria-labelledby": e.label || "Checkbox Label",
          checked: e.checked,
          type: "checkbox",
          value: e.value,
          class: ["checkbox-input", { "cursor-pointer": !e.disabled, "cursor-not-allowed hover:!ring-0": e.disabled }, (b = e.classes) == null ? void 0 : b.input],
          disabled: e.disabled
        }, { ...a.$attrs, class: "", style: {} }, { onChange: d }), null, 16, Ml),
        e.label && !((f = s(l)) != null && f.checkboxLabel) ? (t(), n("label", {
          key: 0,
          for: e.id,
          class: o(["checkbox-label flex flex-col", { "!text-app-gray-400 !cursor-not-allowed": e.disabled }, (v = e.classes) == null ? void 0 : v.label, e.disabled && ((y = e.classes) == null ? void 0 : y.disabled)])
        }, [
          m("span", null, x(e.label), 1),
          e.description ? (t(), n("span", El, x(e.description), 1)) : u("", !0)
        ], 10, Fl)) : u("", !0),
        (h = s(l)) != null && h.checkboxLabel ? (t(), n("label", {
          key: 1,
          for: e.id
        }, [
          $(a.$slots, "checkboxLabel", {}, void 0, !0)
        ], 8, Nl)) : u("", !0)
      ], 2);
    };
  }
});
const We = /* @__PURE__ */ A(Ol, [["__scopeId", "data-v-35795cd9"]]), Qs = /* @__PURE__ */ z({
  __name: "CheckboxGroup",
  props: {
    items: { default: () => [] },
    modelValue: { default: () => [] },
    disabledAll: { type: Boolean, default: !1 },
    labelPlacement: { default: "right" },
    row: { type: Boolean, default: !1 },
    classes: { default: () => ({}) },
    checkboxClasses: { default: () => ({}) }
  },
  emits: ["onChange", "update:modelValue"],
  setup(e, { emit: i }) {
    const l = e, d = M(l.modelValue), a = P(() => new Set(d.value)), r = (c, b) => {
      !c && a.value.has(b) ? a.value.delete(b) : a.value.add(b), d.value = [...a.value], i("update:modelValue", d.value), i("onChange", d.value);
    };
    return me(
      () => l.modelValue,
      () => {
        d.value = [...l.modelValue];
      }
    ), (c, b) => {
      var f;
      return t(), n("div", {
        class: o(["flex flex-col gap-3", { "!flex-row !gap-4": e.row }, (f = e.classes) == null ? void 0 : f.container])
      }, [
        (t(!0), n(te, null, ae(e.items, (v, y) => {
          var h;
          return t(), S(s(We), {
            id: v.id,
            key: v.id,
            label: v.label,
            value: v.value,
            description: v.description,
            checked: (h = d.value) == null ? void 0 : h.includes(v.value),
            disabled: e.disabledAll || v.disabled,
            "label-placement": e.labelPlacement,
            "tab-index": y,
            classes: { ...e.checkboxClasses },
            onOnChange: r
          }, null, 8, ["id", "label", "value", "description", "checked", "disabled", "label-placement", "tab-index", "classes"]);
        }), 128))
      ], 2);
    };
  }
}), jl = { class: "combo-container flex flex-col" }, Rl = { class: "text-sm mb-1 font-body text-app-text-600 dark:text-app-text-dark-500" }, Ul = {
  key: 0,
  class: "flex mt-1 px-1"
}, Kl = { class: "text-app-error text-xs font-body" }, Gl = { class: "z-20" }, Hl = { class: "w-full absolute bg-white dark:bg-app-gray-700 rounded-md shadow dark:shadow-dark overflow-hidden" }, Wl = ["onClick", "onKeydown"], Zl = /* @__PURE__ */ z({
  __name: "ComboBox",
  props: {
    label: { default: "" },
    items: null,
    modelValue: null,
    errors: { default: () => [] }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: i }) {
    const l = e, d = P({
      get: () => l.modelValue,
      set: (f) => i("update:modelValue", f)
    }), a = M(!1), r = P(() => l.items.filter((f) => f.text.toLowerCase().indexOf(d.value.toLowerCase()) >= 0)), c = (f) => {
      d.value = f.value, a.value = !1;
    }, b = () => {
      setTimeout(() => {
        a.value = !1;
      }, 500);
    };
    return (f, v) => (t(), n("div", jl, [
      ve(m("div", {
        class: "absolute inset-0 z-10",
        onClick: v[0] || (v[0] = (y) => a.value = !1),
        onKeydown: v[1] || (v[1] = (y) => a.value = !1)
      }, null, 544), [
        [pe, s(r).length > 0 && a.value]
      ]),
      m("div", Rl, x(e.label), 1),
      ve(m("input", {
        "onUpdate:modelValue": v[2] || (v[2] = (y) => ye(d) ? d.value = y : null),
        "aria-label": "input",
        type: "text",
        class: "combo-input-field",
        onFocus: v[3] || (v[3] = (y) => a.value = !0),
        onBlur: b
      }, null, 544), [
        [Ue, s(d)]
      ]),
      e.errors.length ? (t(), n("div", Ul, [
        m("div", Kl, x(e.errors[0].$message), 1)
      ])) : u("", !0),
      ve(m("div", Gl, [
        m("ul", Hl, [
          (t(!0), n(te, null, ae(s(r), (y) => (t(), n("li", {
            key: y.text,
            class: "text-app-text-500 py-3 text-sm dark:text-app-text-dark-500 hover:bg-app-gray-200 dark:hover:bg-app-gray-500 cursor-pointer px-4",
            onClick: (h) => c(y),
            onKeydown: (h) => c(y)
          }, x(y.text), 41, Wl))), 128))
        ])
      ], 512), [
        [pe, s(r).length > 0 && a.value]
      ])
    ]));
  }
});
const Ys = /* @__PURE__ */ A(Zl, [["__scopeId", "data-v-025e2825"]]), _s = /* @__PURE__ */ z({
  __name: "CopyButton",
  props: {
    showIcon: { type: Boolean, default: !0 },
    iconProps: { default: () => ({
      copyIcon: "document-duplicate-icon",
      copiedIcon: "check-circle-solid-icon",
      size: "18",
      placement: "left"
    }) },
    labelProps: { default: () => ({
      label: "",
      copiedLabel: "",
      style: ""
    }) },
    copyText: { default: "" }
  },
  emits: ["onClick"],
  setup(e, { emit: i }) {
    const l = e, d = M(!1), a = () => {
      l.copyText !== "" && (navigator.clipboard.writeText(l.copyText), d.value = !0, i("onClick"), setTimeout(() => {
        d.value = !1;
      }, (l == null ? void 0 : l.labelProps.time) || 3e3));
    }, r = q();
    return (c, b) => (t(), S(s(le), de({ variant: "tertiary", size: "sm", pill: !0, ...c.$attrs }, {
      onClick: N(a, ["stop"])
    }), {
      default: O(() => {
        var f, v, y, h, k, C;
        return [
          (f = s(r)) != null && f.customLabel ? u("", !0) : (t(), n("span", {
            key: 0,
            class: o(["flex items-center gap-1 justify-between", { "flex-row-reverse": e.iconProps.placement === "right" }])
          }, [
            e.showIcon ? (t(), S(s(V), {
              key: 0,
              name: d.value ? ((v = e.iconProps) == null ? void 0 : v.copiedIcon) || "" : ((y = e.iconProps) == null ? void 0 : y.copyIcon) || "",
              size: e.iconProps.size,
              class: o(["w-[18px]", ((h = e.iconProps) == null ? void 0 : h.style) || ""])
            }, null, 8, ["name", "size", "class"])) : u("", !0),
            m("span", {
              class: o(["flex items-center capitalize", (k = e.labelProps) == null ? void 0 : k.style])
            }, x(d.value ? e.labelProps.copiedLabel : e.labelProps.label), 3)
          ], 2)),
          (C = s(r)) != null && C.customLabel ? $(c.$slots, "customLabel", { key: 1 }) : u("", !0)
        ];
      }),
      _: 3
    }, 16, ["onClick"]));
  }
}), ql = { key: 0 }, Jl = ["checked"], Xl = ["onKeydown"], en = /* @__PURE__ */ z({
  __name: "Dialog",
  props: {
    modelValue: { type: Boolean, default: void 0 },
    value: { type: Boolean, default: void 0 },
    width: { default: 100 },
    class: { default: "" }
  },
  emits: ["onClose", "update:modelValue"],
  setup(e, { emit: i }) {
    const l = e, d = P(() => l.class), a = P(() => l.value !== void 0 ? l.value : l.modelValue), r = P(() => `${l.width}px`), c = () => {
      l.value !== void 0 && i("onClose", !1), i("update:modelValue", !1);
    };
    return (b, f) => s(a) ? (t(), n("div", ql, [
      m("input", {
        type: "checkbox",
        checked: s(a),
        class: "modal-toggle",
        "aria-label": "dialog-checkbox"
      }, null, 8, Jl),
      m("div", {
        class: "modal cursor-pointer",
        onClick: c,
        onKeydown: ne(c, ["esc"])
      }, [
        m("div", {
          class: o(["modal-box pa-0 relative", s(d)]),
          style: oe({ width: s(r) }),
          onClick: f[0] || (f[0] = N(() => {
          }, ["stop"]))
        }, [
          $(b.$slots, "default")
        ], 6)
      ], 40, Xl)
    ])) : u("", !0);
  }
}), Ql = (e) => (ge("data-v-a9e61aaf"), e = e(), xe(), e), Yl = /* @__PURE__ */ Ql(() => /* @__PURE__ */ m("hr", null, null, -1)), _l = [
  Yl
], et = /* @__PURE__ */ z({
  __name: "Divider",
  props: {
    type: { default: "horizontal" },
    classes: { default: () => ({}) }
  },
  setup(e) {
    const i = e, l = P(() => {
      var d;
      return ["divider", `divider-${i.type}`, (d = i.classes) == null ? void 0 : d.root];
    });
    return (d, a) => (t(), n("div", {
      class: o(["divider w-full", s(l)])
    }, _l, 2));
  }
});
const ln = /* @__PURE__ */ A(et, [["__scopeId", "data-v-a9e61aaf"]]), Ze = (e) => (ge("data-v-f6180c1d"), e = e(), xe(), e), lt = { key: 0 }, tt = ["id"], at = /* @__PURE__ */ Ze(() => /* @__PURE__ */ m("span", { class: "sr-only" }, "Close menu", -1)), st = ["data-drawer-backdrop"], nt = /* @__PURE__ */ Ze(() => /* @__PURE__ */ m("span", { class: "sr-only" }, "Close menu", -1)), ot = /* @__PURE__ */ z({
  __name: "Drawer",
  props: {
    id: { default: "" },
    open: { type: Boolean, default: !1 },
    sidebarCloseIcon: { type: Boolean, default: !1 },
    backdropCloseIcon: { type: Boolean, default: !0 },
    placement: { default: "left" },
    backdropClose: { type: Boolean, default: !0 },
    classes: { default: () => ({}) }
  },
  emits: ["onClose"],
  setup(e, { emit: i }) {
    return (l, d) => {
      var a, r, c, b;
      return e.open ? (t(), n("div", lt, [
        m("div", {
          id: e.id,
          class: o(["drawer-sidebar", `${e.placement}-0`, (a = e.classes) == null ? void 0 : a.container]),
          tabindex: "-1",
          "aria-labelledby": "drawer-label"
        }, [
          e.sidebarCloseIcon ? (t(), n("button", {
            key: 0,
            type: "button",
            "data-drawer-hide": "drawer-close",
            "aria-controls": "drawer-close",
            class: o(["close-btn right-2.5", (r = e.classes) == null ? void 0 : r.sidebarCloseBtn]),
            onClick: d[0] || (d[0] = (f) => i("onClose")),
            onKeydown: d[1] || (d[1] = ne((f) => i("onClose"), ["esc"]))
          }, [
            R(s(V), {
              name: "x-icon",
              size: "15",
              class: o(["w-[15px]", e.classes.sidebarCloseIcon || ""])
            }, null, 8, ["class"]),
            at
          ], 34)) : u("", !0),
          $(l.$slots, "sidebar", {}, void 0, !0)
        ], 10, tt),
        m("div", {
          "aria-hidden": "",
          "data-drawer-backdrop": e.backdropClose,
          class: o(["backdrop-container", (c = e.classes) == null ? void 0 : c.backdropContainer]),
          onClick: d[4] || (d[4] = (f) => e.backdropClose && i("onClose"))
        }, [
          m("div", null, [
            e.backdropCloseIcon ? (t(), n("button", {
              key: 0,
              type: "button",
              "data-drawer-hide": "drawer-close",
              "aria-controls": "drawer-close",
              class: o([
                "close-btn !text-app-white hover:!bg-transparent dark:hover:!bg-transparent !top-1.5",
                { "right-1.5": e.placement === "left", "left-1.5": e.placement === "right" },
                (b = e.classes) == null ? void 0 : b.backdropCloseBtn
              ]),
              onClick: d[2] || (d[2] = (f) => i("onClose")),
              onKeydown: d[3] || (d[3] = ne((f) => i("onClose"), ["esc"]))
            }, [
              R(s(V), {
                name: "x-icon",
                size: "15",
                class: o(["w-[15px]", e.classes.backdropCloseIcon || ""])
              }, null, 8, ["class"]),
              nt
            ], 34)) : u("", !0)
          ])
        ], 10, st)
      ])) : u("", !0);
    };
  }
});
const tn = /* @__PURE__ */ A(ot, [["__scopeId", "data-v-f6180c1d"]]), dt = ["id", "onClick"], it = {
  key: 0,
  class: "flex items-center gap-2"
}, ct = { class: "flex items-center" }, ut = { class: "flex flex-col" }, rt = {
  key: 0,
  class: "mt-0.5 text-xs font-normal text-app-gray-500"
}, ft = { class: "flex items-center" }, vt = /* @__PURE__ */ z({
  __name: "Dropdown",
  props: {
    label: { default: "" },
    labelIcon: { default: "chevron-down-solid-icon" },
    rounded: { type: Boolean, default: !1 },
    open: { type: Boolean, default: !1 },
    id: { default: "" },
    items: { default: () => [] },
    classes: { default: () => ({}) },
    buttonProps: { default: () => ({ size: "md" }) },
    modelValue: { default: "" },
    error: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    helperText: { default: "" },
    iconPlacement: { default: "left" },
    badgeType: { default: "pill" }
  },
  emits: ["update:modelValue", "onBtnClick", "onItemClick"],
  setup(e, { emit: i }) {
    const l = e, d = q(), a = M(l.open), r = M(l.modelValue), c = M(null), b = () => {
      a.value = !a.value, i("onBtnClick");
    }, f = () => a.value = !1, v = (h, k) => {
      i("onItemClick", h, k), i("update:modelValue", h.value), r.value = h.value, a.value = !1;
    }, y = (h) => {
      c.value && !c.value.contains(h.target) && (a.value = !1);
    };
    return me(
      () => a.value,
      (h) => {
        h ? document.addEventListener("click", y) : document.removeEventListener("click", y);
      }
    ), (h, k) => {
      var C, g, p;
      return t(), n("div", {
        id: e.id,
        ref_key: "torusDropdown",
        ref: c,
        class: o(["relative", (C = e.classes) == null ? void 0 : C.container]),
        "aria-hidden": "",
        onClick: N(f, ["exact", "self"])
      }, [
        R(s(le), de({
          classes: { container: `dropdown-button ${(g = e.classes) == null ? void 0 : g.dropdownBtn}` },
          "data-dropdown-toggle": "dropdown",
          rounded: e.rounded
        }, e.buttonProps, {
          disabled: e.disabled,
          onOnClick: b,
          onKeydown: ne(N(f, ["exact", "stop"]), ["esc"])
        }), {
          default: O(() => [
            $(h.$slots, "dropDownLabel", {}, () => {
              var I;
              return [
                e.label ? (t(), n("div", it, [
                  Z(x(e.label) + " ", 1),
                  R(s(V), {
                    name: e.labelIcon,
                    class: o(["ml-1", ((I = e.classes) == null ? void 0 : I.labelIcon) || ""])
                  }, null, 8, ["name", "class"])
                ])) : u("", !0)
              ];
            }, !0)
          ]),
          _: 3
        }, 16, ["classes", "rounded", "disabled", "onKeydown"]),
        R(Ke, { name: "dropdown-fade" }, {
          default: O(() => {
            var I, T, D;
            return [
              ve(m("div", {
                class: o([
                  "absolute left-0 z-10 mt-2 bg-app-white divide-y divide-app-gray-100 rounded drop-shadow-xl w-44 dark:bg-app-white border border-app-gray-200",
                  (I = e.classes) == null ? void 0 : I.menuContainer
                ])
              }, [
                !s(d).options && e.items && ((T = e.items) == null ? void 0 : T.length) > 0 ? (t(), n("ul", {
                  key: 0,
                  class: o(["py-1 text-sm text-app-gray-700 dark:text-app-gray-200", (D = e.classes) == null ? void 0 : D.itemContainer]),
                  "aria-labelledby": "dropdownDefaultButton"
                }, [
                  (t(!0), n(te, null, ae(e.items, (w, E) => {
                    var j, H, J;
                    return t(), n("li", {
                      key: w.name
                    }, [
                      (t(), S(he(w != null && w.href ? "a" : "div"), {
                        href: w == null ? void 0 : w.href,
                        class: o([
                          "px-4 py-2 text-app-gray-600 flex items-center justify-between",
                          E !== e.items.length - 1 && "border-b",
                          !(w != null && w.disabled) && "cursor-pointer hover:bg-app-gray-50 dark:hover:bg-app-gray-100 dark:hover:text-app-gray-500",
                          (w == null ? void 0 : w.disabled) && "cursor-not-allowed",
                          r.value === w.value && "font-medium",
                          r.value === w.value && (((j = e.classes) == null ? void 0 : j.activeItem) || "bg-app-gray-50 text-app-gray-900"),
                          (w == null ? void 0 : w.disabled) && (((H = e.classes) == null ? void 0 : H.disabledItem) || "text-app-gray-300"),
                          (J = e.classes) == null ? void 0 : J.item
                        ]),
                        onClick: N((U) => !(w != null && w.disabled) && v(w, E), ["stop"])
                      }, {
                        default: O(() => {
                          var U, W;
                          return [
                            m("div", ct, [
                              w != null && w.icon && e.iconPlacement === "left" ? (t(), S(s(V), {
                                key: 0,
                                name: w.icon,
                                size: "18",
                                class: o(["mr-2 shrink-0 w-[18px]", ((U = e.classes) == null ? void 0 : U.itemIcon) || ""])
                              }, null, 8, ["name", "class"])) : u("", !0),
                              m("div", ut, [
                                Z(x(w.name) + " ", 1),
                                w.description ? (t(), n("div", rt, x(w.description), 1)) : u("", !0)
                              ])
                            ]),
                            m("span", ft, [
                              w != null && w.icon && e.iconPlacement === "right" ? (t(), S(s(V), {
                                key: 0,
                                name: w.icon,
                                size: "18",
                                class: o(["mr-2 w-[18px]", ((W = e.classes) == null ? void 0 : W.itemIcon) || ""])
                              }, null, 8, ["name", "class"])) : u("", !0),
                              w != null && w.badge ? (t(), S(s(gl), {
                                key: 1,
                                variant: (w == null ? void 0 : w.badgeType) || "default",
                                class: o([e.badgeType !== "default" && "!w-auto !h-auto", e.classes.itemBadge]),
                                pill: e.badgeType !== "default"
                              }, {
                                default: O(() => [
                                  Z(x(w == null ? void 0 : w.badge), 1)
                                ]),
                                _: 2
                              }, 1032, ["variant", "class", "pill"])) : u("", !0)
                            ])
                          ];
                        }),
                        _: 2
                      }, 1032, ["href", "class", "onClick"]))
                    ]);
                  }), 128))
                ], 2)) : u("", !0),
                s(d).options ? $(h.$slots, "options", { key: 1 }, void 0, !0) : u("", !0)
              ], 2), [
                [pe, a.value]
              ])
            ];
          }),
          _: 3
        }),
        e.helperText ? (t(), n("p", {
          key: 0,
          class: o([
            "text-xs font-normal mt-1",
            e.success && !e.disabled ? "success-msg" : e.error && !e.disabled ? "error-msg" : "default-msg",
            (p = e.classes) == null ? void 0 : p.helperText
          ])
        }, x(e.helperText), 3)) : u("", !0)
      ], 10, dt);
    };
  }
});
const an = /* @__PURE__ */ A(vt, [["__scopeId", "data-v-c8721a3b"]]), bt = ["id", "aria-expanded", "aria-controls", "aria-label"], mt = ["data-accordion-target", "aria-expanded"], yt = {
  key: 0,
  class: /* @__PURE__ */ o(["flex-1"])
}, ht = {
  key: 1,
  class: /* @__PURE__ */ o(["flex-1"])
}, gt = { key: 0 }, xt = /* @__PURE__ */ z({
  __name: "ExpansionPanel",
  props: {
    title: { default: "" },
    text: { default: "" },
    id: { default: "" },
    expand: { type: Boolean, default: !1 },
    flushedPanel: { type: Boolean, default: !1 },
    borderRadiusTop: { type: Boolean, default: !0 },
    borderRadiusBottom: { type: Boolean, default: !1 },
    showArrowIcon: { type: Boolean, default: !0 },
    classes: { default: () => ({}) },
    arrowUpIcon: { default: "chevron-up-solid-icon" },
    arrowDownIcon: { default: "chevron-down-solid-icon" }
  },
  emits: ["onToggle"],
  setup(e, { emit: i }) {
    const l = q();
    return (d, a) => {
      var r, c, b, f, v, y, h;
      return t(), n("div", {
        id: e.id,
        "data-accordion": "collapse",
        class: o([(r = e.classes) == null ? void 0 : r.container]),
        "aria-expanded": e.expand,
        "aria-controls": e.text || "expansion-panel-control",
        "aria-label": e.title || "expansion-panel-label"
      }, [
        m("h2", null, [
          m("button", {
            type: "button",
            class: o([
              "panel-heading",
              { "panel-active": ((c = e.classes) == null ? void 0 : c.activePanel) || e.expand, "panel-flushed": ((b = e.classes) == null ? void 0 : b.flushedPanel) || e.flushedPanel, "rounded-t-lg": e.borderRadiusTop },
              (f = e.classes) == null ? void 0 : f.headingContainer
            ]),
            "data-accordion-target": `#accordion-collapse-body-${e.id || "0"}`,
            "aria-expanded": e.expand,
            "aria-controls": "accordion-collapse-body",
            onClick: a[0] || (a[0] = (k) => i("onToggle", e.expand))
          }, [
            !s(l).panelTitle && e.title ? (t(), n("span", yt, x(e.title), 1)) : u("", !0),
            s(l).panelTitle ? (t(), n("span", ht, [
              $(d.$slots, "panelTitle", {}, void 0, !0)
            ])) : u("", !0),
            !s(l).panelArrowIcon && e.showArrowIcon ? (t(), S(s(V), {
              key: 2,
              name: e.expand ? e.arrowUpIcon : e.arrowDownIcon,
              size: "24",
              class: o(["w-6", ((v = e.classes) == null ? void 0 : v.arrowIcon) || ""])
            }, null, 8, ["name", "class"])) : u("", !0),
            s(l).panelArrowIcon && e.showArrowIcon ? $(d.$slots, "panelArrowIcon", { key: 3 }, void 0, !0) : u("", !0)
          ], 10, mt)
        ]),
        m("div", {
          class: o([{ hidden: !e.expand }]),
          "aria-labelledby": "accordion-collapse-heading"
        }, [
          m("div", {
            class: o([
              "panel-body",
              { "rounded-b-lg": e.borderRadiusBottom, "panel-flushed": ((y = e.classes) == null ? void 0 : y.flushedPanel) || e.flushedPanel },
              (h = e.classes) == null ? void 0 : h.bodyContainer
            ])
          }, [
            !s(l).panelBody && e.text ? (t(), n("span", gt, x(e.text), 1)) : u("", !0),
            s(l).panelBody ? $(d.$slots, "panelBody", { key: 1 }, void 0, !0) : u("", !0)
          ], 2)
        ], 2)
      ], 10, bt);
    };
  }
});
const sn = /* @__PURE__ */ A(xt, [["__scopeId", "data-v-c62a081e"]]), kt = {
  key: 0,
  class: "upload-button-container"
}, wt = ["id", "disabled", "accept", "multiple"], $t = { key: 1 }, pt = { key: 2 }, Ct = { class: "rounded-r-lg h-full flex-1 flex items-center justify-between px-4 py-3 bg-app-gray-50 border border-app-gray-300 text-app-gray-900 text-sm font-normal dark:text-app-white dark:bg-app-gray-700 dark:border-app-gray-600" }, It = { key: 1 }, Bt = { key: 1 }, Tt = ["for"], Lt = {
  key: 0,
  class: /* @__PURE__ */ o(["flex flex-col items-center justify-center"])
}, St = {
  key: 0,
  class: /* @__PURE__ */ o(["flex items-center justify-between"])
}, zt = { key: 1 }, Pt = { key: 1 }, Dt = ["id", "multiple", "accept", "disabled"], Vt = {
  key: 0,
  class: "flex items-center flex-col"
}, At = {
  key: 1,
  class: "flex items-center flex-col"
}, Mt = /* @__PURE__ */ z({
  __name: "Fileuploader",
  props: {
    variant: { default: "dragger" },
    title: { default: "Click to upload or drag and drop" },
    description: { default: "SVG, PNG, JPG or GIF (MAX. 800x400px)" },
    fileSizeText: { default: "" },
    acceptedFile: { default: () => [".pdf", "jpg"] },
    id: { default: "" },
    multiple: { type: Boolean, default: !1 },
    showButton: { type: Boolean, default: !1 },
    showButtonIcon: { type: Boolean, default: !1 },
    btnLabel: { default: "Browse Files" },
    disabled: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    btnIconName: { default: "search-solid-icon" },
    uploadIconName: { default: "cloud-upload-icon" },
    helperText: { default: "" },
    docIconName: { default: "document-text-icon" },
    clearBtnLabel: { default: "Clear" },
    classes: { default: () => ({}) }
  },
  emits: ["onFileupload", "onClear"],
  setup(e, { emit: i }) {
    const l = e, d = M(""), a = q(), r = (y) => {
      y.preventDefault();
    };
    function c(y) {
      var k, C;
      const h = (k = y == null ? void 0 : y.target) == null ? void 0 : k.files;
      d.value = l.multiple && h && (h == null ? void 0 : h.length) > 1 ? `No of files uploaded ${h == null ? void 0 : h.length}` : h && ((C = h == null ? void 0 : h[0]) == null ? void 0 : C.name) || "", i("onFileupload", h);
    }
    function b(y) {
      var h;
      d.value = l.multiple && y && (y == null ? void 0 : y.length) > 1 ? `No of files uploaded ${y.length}` : y && ((h = y == null ? void 0 : y[0]) == null ? void 0 : h.name) || "", i("onFileupload", y);
    }
    function f(y) {
      var k;
      y.preventDefault();
      const h = (k = y == null ? void 0 : y.dataTransfer) == null ? void 0 : k.files;
      b(h);
    }
    function v() {
      d.value = "", i("onClear");
    }
    return (y, h) => {
      var k, C, g, p, I, T, D, w, E, j, H, J, U, W, Q, _, K, X, ue;
      return t(), n("div", null, [
        e.variant === "button" ? (t(), n("div", kt, [
          R(s(le), {
            component: "label",
            for: e.id,
            classes: {
              container: e.disabled ? "!cursor-not-allowed !bg-app-gray-200 upload-button" : "upload-button !bg-app-gray-800 dark:!bg-app-gray-600"
            }
          }, {
            default: O(() => {
              var ie, ce, se, re;
              return [
                m("input", {
                  id: e.id,
                  ref: "fileInput",
                  "aria-labelledby": "upload",
                  type: "file",
                  class: "hidden",
                  disabled: e.disabled,
                  accept: e.acceptedFile.join(" ,"),
                  multiple: e.multiple,
                  onChange: c
                }, null, 40, wt),
                e.showButtonIcon && !((ie = s(a)) != null && ie.buttonTitle) ? (t(), S(s(V), {
                  key: 0,
                  class: o(["mr-1 w-5", ((ce = e.classes) == null ? void 0 : ce.ctaBtnIcon) || ""]),
                  name: e.btnIconName,
                  size: "20"
                }, null, 8, ["class", "name"])) : u("", !0),
                (se = s(a)) != null && se.buttonTitle ? u("", !0) : (t(), n("span", $t, x(e.btnLabel), 1)),
                (re = s(a)) != null && re.buttonTitle ? (t(), n("span", pt, [
                  $(y.$slots, "buttonTitle", {}, void 0, !0)
                ])) : u("", !0)
              ];
            }),
            _: 3
          }, 8, ["for", "classes"]),
          m("div", Ct, [
            (k = s(a)) != null && k.buttonFileName ? u("", !0) : (t(), n("span", {
              key: 0,
              class: o([(C = e.classes) == null ? void 0 : C.fileName])
            }, x(d.value || "No file chosen"), 3)),
            (g = s(a)) != null && g.buttonFileName ? (t(), n("span", It, [
              $(y.$slots, "buttonFileName", {}, void 0, !0)
            ])) : u("", !0),
            d.value ? (t(), S(s(le), {
              key: 2,
              variant: "text",
              class: o([(p = e.classes) == null ? void 0 : p.clearBtn]),
              onOnClick: v
            }, {
              default: O(() => [
                Z(x(e.clearBtnLabel), 1)
              ]),
              _: 1
            }, 8, ["class"])) : u("", !0)
          ])
        ])) : u("", !0),
        e.variant === "dragger" ? (t(), n("div", Bt, [
          d.value ? u("", !0) : (t(), n("label", {
            key: 0,
            for: e.id,
            class: o(["upload-box-container", { "!cursor-not-allowed": e.disabled }, (I = e.classes) == null ? void 0 : I.container]),
            onDragover: r,
            onDrop: f
          }, [
            (T = s(a)) != null && T.uploadBody ? u("", !0) : (t(), n("span", Lt, [
              R(s(V), {
                name: e.uploadIconName,
                class: o(["!text-app-gray-400", "dark:!text-app-gray-500", ((D = e.classes) == null ? void 0 : D.uploadIcon) || ""])
              }, null, 8, ["name", "class"]),
              m("p", {
                class: o(["mt-3 text-sm font-normal text-app-gray-500 dark:text-app-gray-400", (w = e.classes) == null ? void 0 : w.title])
              }, x(e.title), 3),
              m("p", {
                class: o(["mt-1 text-xs font-normal text-app-gray-500 dark:text-app-gray-400", (E = e.classes) == null ? void 0 : E.description])
              }, x(e.description), 3),
              e.fileSizeText ? (t(), n("p", {
                key: 0,
                class: o(["mt-1 text-xs font-semibold text-app-gray-500 dark:text-app-gray-400", (j = e.classes) == null ? void 0 : j.fileSizeText])
              }, x(e.fileSizeText), 3)) : u("", !0),
              e.showButton ? (t(), S(s(le), {
                key: 1,
                component: "label",
                size: "xs",
                class: o([
                  "flex mt-4 !items-center !justify-between cursor-pointer",
                  { "!bg-app-gray-200 !cursor-not-allowed !border-0": e.disabled },
                  (H = e.classes) == null ? void 0 : H.ctaBtn
                ]),
                for: e.id,
                disabled: e.disabled
              }, {
                default: O(() => {
                  var ie, ce, se;
                  return [
                    (ie = s(a)) != null && ie.buttonTitle ? u("", !0) : (t(), n("span", St, [
                      e.showButtonIcon ? (t(), S(s(V), {
                        key: 0,
                        class: o(["mr-1 w-4", ((ce = e.classes) == null ? void 0 : ce.ctaBtnIcon) || ""]),
                        name: e.btnIconName,
                        size: "16"
                      }, null, 8, ["class", "name"])) : u("", !0),
                      Z(" " + x(e.btnLabel), 1)
                    ])),
                    (se = s(a)) != null && se.buttonTitle ? (t(), n("span", zt, [
                      $(y.$slots, "buttonTitle", {}, void 0, !0)
                    ])) : u("", !0)
                  ];
                }),
                _: 3
              }, 8, ["class", "for", "disabled"])) : u("", !0)
            ])),
            (J = s(a)) != null && J.uploadBody ? (t(), n("span", Pt, [
              $(y.$slots, "uploadBody", {}, void 0, !0)
            ])) : u("", !0),
            m("input", {
              id: e.id,
              ref: "fileInput",
              type: "file",
              class: "hidden",
              multiple: e.multiple,
              accept: e.acceptedFile.join(" ,"),
              disabled: e.disabled,
              onChange: c
            }, null, 40, Dt)
          ], 42, Tt)),
          d.value ? (t(), n("div", {
            key: 1,
            class: o([
              "upload-box-container !border-solid",
              { "upload-box-success-container": e.success, "upload-box-error-container": e.error },
              (U = e.classes) == null ? void 0 : U.uploadedContainer
            ])
          }, [
            (W = s(a)) != null && W.uploadedFileBody ? u("", !0) : (t(), n("span", Vt, [
              R(s(V), {
                name: e.docIconName,
                class: o(["text-app-gray-500 dark:text-app-gray-400", ((Q = e.classes) == null ? void 0 : Q.docIcon) || ""])
              }, null, 8, ["name", "class"]),
              m("p", {
                class: o(["text-sm font-normal text-app-gray-500 dark:text-app-gray-400 mt-4", (_ = e.classes) == null ? void 0 : _.fileName])
              }, x(d.value), 3),
              R(s(le), {
                variant: "text",
                class: o(["mt-4", (K = e.classes) == null ? void 0 : K.clearBtn]),
                onOnClick: v
              }, {
                default: O(() => [
                  Z(x(e.clearBtnLabel), 1)
                ]),
                _: 1
              }, 8, ["class"])
            ])),
            (X = s(a)) != null && X.uploadedFileBody ? (t(), n("span", At, [
              $(y.$slots, "uploadedFileBody", {}, void 0, !0)
            ])) : u("", !0)
          ], 2)) : u("", !0)
        ])) : u("", !0),
        e.helperText ? (t(), n("p", {
          key: 2,
          class: o(["text-xs font-normal mt-1 helperText", { "helperText-success": e.success, "helperText-error": e.error }, (ue = e.classes) == null ? void 0 : ue.helperText])
        }, x(e.helperText), 3)) : u("", !0)
      ]);
    };
  }
});
const nn = /* @__PURE__ */ A(Mt, [["__scopeId", "data-v-05bb6a32"]]), Ft = ["disabled", "onClick"], Et = /* @__PURE__ */ z({
  __name: "ListGroup",
  props: {
    items: null,
    block: { type: Boolean },
    classes: { default: () => ({}) }
  },
  emits: ["onClick"],
  setup(e, { emit: i }) {
    const l = q();
    return (d, a) => {
      var r;
      return t(), n("div", {
        class: o(["listGroup-container", { block: e.block }, (r = e.classes) == null ? void 0 : r.container])
      }, [
        s(l).listItems ? u("", !0) : (t(!0), n(te, { key: 0 }, ae(e.items, (c, b) => {
          var f, v;
          return t(), n("button", {
            key: c.name,
            type: "button",
            class: o(["listGroup-button", b !== e.items.length - 1 && "border-b", (f = e.classes) == null ? void 0 : f.itemContainer]),
            disabled: c.disabled,
            role: "listitem",
            onClick: (y) => i("onClick", c)
          }, [
            c.icon ? (t(), S(s(V), {
              key: 0,
              name: c.icon,
              class: o(["mr-2", ((v = e.classes) == null ? void 0 : v.itemIcon) || ""])
            }, null, 8, ["name", "class"])) : u("", !0),
            Z(" " + x(c.name), 1)
          ], 10, Ft);
        }), 128)),
        s(l).listItems ? (t(), n("div", {
          key: 1,
          class: o([e.classes.listItem])
        }, [
          $(d.$slots, "listItems", {}, void 0, !0)
        ], 2)) : u("", !0)
      ], 2);
    };
  }
});
const on = /* @__PURE__ */ A(Et, [["__scopeId", "data-v-dd8d0863"]]), Nt = {
  key: 1,
  class: "ping-container"
}, Ot = ["src"], jt = ["src"], Rt = /* @__PURE__ */ z({
  __name: "Loader",
  props: {
    size: { default: 60 },
    logoLight: { default: "https://images.web3auth.io/web3auth-logo-w-light.svg" },
    logoDark: { default: "https://images.web3auth.io/web3auth-logo-w.svg" },
    useSpinner: { type: Boolean, default: !1 },
    classes: { default: () => ({}) }
  },
  setup(e) {
    const i = e, l = P(() => ({
      width: `${i.size}px`,
      height: `${i.size}px`
    })), d = P(() => ({
      left: `${Math.ceil(i.size / 2) - 4}px`
    })), a = P(() => ({ width: `${i.size - 10}px`, height: `${i.size - 10}px` })), r = P(() => ({ width: `${i.size}px`, height: `${i.size}px` })), c = P(() => {
      const b = i.size * 0.56;
      return { width: `${b}px`, height: `${b}px` };
    });
    return (b, f) => {
      var v, y, h;
      return t(), n("div", null, [
        e.useSpinner ? (t(), n("div", {
          key: 0,
          class: o(["spinner", (v = e.classes) == null ? void 0 : v.spinnerContainer]),
          style: oe(s(l))
        }, [
          m("div", {
            class: o(["head", (y = e.classes) == null ? void 0 : y.spinnerHead]),
            style: oe(s(d))
          }, null, 6),
          m("div", {
            class: o(["mask", (h = e.classes) == null ? void 0 : h.spinnerMask]),
            style: oe(s(a))
          }, null, 6)
        ], 6)) : (t(), n("div", Nt, [
          m("div", {
            class: o(["ping-animate", e.classes.pingAnimate])
          }, null, 2),
          m("div", {
            class: o(["ping-content", e.classes.pingContent]),
            style: oe(s(r))
          }, [
            m("img", {
              class: "block dark:hidden",
              src: e.logoLight,
              alt: "Web3Auth",
              style: oe(s(c))
            }, null, 12, Ot),
            m("img", {
              class: "hidden dark:block",
              src: e.logoDark,
              alt: "Web3Auth",
              style: oe(s(c))
            }, null, 12, jt)
          ], 6)
        ]))
      ]);
    };
  }
});
const dn = /* @__PURE__ */ A(Rt, [["__scopeId", "data-v-ba893c8b"]]), Ut = ["for"], Kt = { key: 0 }, Gt = { key: 1 }, Ht = ["id", "type", "placeholder", "aria-placeholder", "aria-labelledby", "disabled"], Wt = { key: 1 }, Zt = { key: 1 }, qt = /* @__PURE__ */ z({
  __name: "TextField",
  props: {
    size: { default: "medium" },
    label: { default: "" },
    placeholder: { default: "" },
    modelValue: { default: "" },
    type: { default: "text" },
    error: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    id: { default: "" },
    helperText: { default: "" },
    trailingIcon: { default: "" },
    endIcon: { default: "" },
    classes: { default: () => ({}) },
    pill: { type: Boolean, default: !1 },
    toolTipIcon: { default: "information-circle-icon" },
    showToolTipIcon: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "onTrailingIconClick", "onEndIconClick", "onTooltipClick"],
  setup(e, { emit: i }) {
    const l = e, d = P({
      get: () => l.modelValue,
      set: (f) => i("update:modelValue", f)
    }), a = M(!1), r = () => {
      a.value = !0;
    }, c = () => a.value = !1, b = q();
    return (f, v) => {
      var y, h, k, C, g, p, I, T, D, w, E, j, H, J, U, W, Q, _;
      return t(), n("div", {
        class: o(["relative w-full items-stretch", f.$attrs.class, (y = e.classes) == null ? void 0 : y.container])
      }, [
        e.label ? (t(), n("label", {
          key: 0,
          for: e.id,
          class: o(["label", e.success && !e.disabled ? "success-label" : e.error && !e.disabled ? "error-label" : "default-label", (h = e.classes) == null ? void 0 : h.label])
        }, [
          Z(x(e.label) + " ", 1),
          e.showToolTipIcon && !((k = s(b)) != null && k.tooltip) ? (t(), S(s(V), {
            key: 0,
            name: e.toolTipIcon,
            size: "15",
            class: o(["ml-1 cursor-pointer w-[15px]", ((C = e.classes) == null ? void 0 : C.toolTipIcon) || ""]),
            onClick: v[0] || (v[0] = N((K) => i("onTooltipClick"), ["stop"]))
          }, null, 8, ["name", "class"])) : u("", !0),
          e.showToolTipIcon && ((g = s(b)) != null && g.tooltip) ? $(f.$slots, "tooltip", { key: 1 }, void 0, !0) : u("", !0)
        ], 10, Ut)) : u("", !0),
        m("div", {
          class: o([
            "relative flex items-center",
            e.success ? "success-container" : e.error ? "error-container" : "default-container",
            e.pill ? "rounded-full" : "rounded-lg",
            `size-${e.size}`,
            a.value ? e.success ? "success-container-focus" : e.error ? "error-container-focus" : "default-container-focus" : "",
            e.disabled && (((p = e.classes) == null ? void 0 : p.disabled) || "disabled-input"),
            (I = e.classes) == null ? void 0 : I.inputContainer
          ])
        }, [
          e.trailingIcon || (T = s(b)) != null && T.trailingIconSlot ? (t(), n("div", Kt, [
            e.trailingIcon && !((D = s(b)) != null && D.trailingIconSlot) ? (t(), S(s(V), {
              key: 0,
              name: e.trailingIcon,
              class: o(["icon mr-2 cursor-pointer", ((w = e.classes) == null ? void 0 : w.trailingIcon) || ""]),
              onClick: v[1] || (v[1] = (K) => i("onTrailingIconClick"))
            }, null, 8, ["name", "class"])) : u("", !0),
            (E = s(b)) != null && E.trailingIconSlot ? (t(), n("span", Gt, [
              $(f.$slots, "trailingIconSlot", {}, void 0, !0)
            ])) : u("", !0)
          ])) : u("", !0),
          ve(m("input", de({
            id: e.id,
            "onUpdate:modelValue": v[2] || (v[2] = (K) => ye(d) ? d.value = K : null),
            role: "textbox",
            type: e.type,
            placeholder: e.placeholder,
            "aria-placeholder": e.placeholder || "TextField Placeholder",
            "aria-labelledby": e.label || "TextField Label",
            disabled: e.disabled,
            class: [
              `size-input-${e.size}`,
              e.pill ? "rounded-full" : "rounded-lg",
              e.success ? "success-input" : e.error ? "error-input" : "default-input",
              "input-root",
              e.disabled && (((j = e.classes) == null ? void 0 : j.disabled) || "disabled-input"),
              (H = e.classes) == null ? void 0 : H.input
            ]
          }, { ...f.$attrs, class: "", style: {} }, {
            onFocus: r,
            onBlur: c
          }), null, 16, Ht), [
            [Xe, s(d)]
          ]),
          e.endIcon || (J = s(b)) != null && J.endIconSlot ? (t(), n("div", Wt, [
            e.endIcon && !((U = s(b)) != null && U.endIconSlot) ? (t(), S(s(V), {
              key: 0,
              name: e.endIcon,
              class: o(["icon ml-2 cursor-pointer", ((W = e.classes) == null ? void 0 : W.endIcon) || ""]),
              onClick: v[3] || (v[3] = N((K) => i("onEndIconClick"), ["stop"]))
            }, null, 8, ["name", "class"])) : u("", !0),
            (Q = s(b)) != null && Q.endIconSlot ? (t(), n("span", Zt, [
              $(f.$slots, "endIconSlot", {}, void 0, !0)
            ])) : u("", !0)
          ])) : u("", !0)
        ], 2),
        e.helperText ? (t(), n("p", {
          key: 1,
          class: o([
            "text-xs font-normal mt-1",
            e.success && !e.disabled ? "success-msg" : e.error && !e.disabled ? "error-msg" : "default-msg",
            (_ = e.classes) == null ? void 0 : _.helperText
          ])
        }, x(e.helperText), 3)) : u("", !0)
      ], 2);
    };
  }
});
const Ce = /* @__PURE__ */ A(qt, [["__scopeId", "data-v-b1dede24"]]), Be = (e) => (ge("data-v-3333b0d9"), e = e(), xe(), e), Jt = {
  key: 0,
  class: "flex items-center justify-center gap-3"
}, Xt = { class: "capitalize" }, Qt = {
  key: 0,
  class: "font-semibold"
}, Yt = {
  key: 1,
  class: "font-semibold"
}, _t = ["src", "alt"], ea = ["src", "alt"], la = ["src", "alt"], ta = {
  key: 4,
  class: "flex items-center mb-2 gap-2"
}, aa = /* @__PURE__ */ Be(() => /* @__PURE__ */ m("div", { class: "h-[1px] w-full bg-app-gray-200 dark:bg-app-gray-600" }, null, -1)), sa = /* @__PURE__ */ Be(() => /* @__PURE__ */ m("span", { class: "text-app-gray-600 dark:text-app-gray-200 text-sm font-normal" }, "or", -1)), na = /* @__PURE__ */ Be(() => /* @__PURE__ */ m("div", { class: "h-[1px] w-full bg-app-gray-200 dark:bg-app-gray-600" }, null, -1)), oa = [
  aa,
  sa,
  na
], da = { key: 5 }, ia = /* @__PURE__ */ z({
  __name: "LoginForm",
  props: {
    socialLogins: { default: () => [] },
    pill: { type: Boolean, default: !1 },
    expandLabel: { default: "View More" },
    collapseLabel: { default: "View Less" },
    socialLoginMessage: { default: "We do not store any data related to your social logins." },
    showInput: { type: Boolean, default: !0 },
    inputBtnLabel: { default: "" },
    inputProps: { default: () => ({}) },
    inputExpandBtnProps: { default: () => ({}) },
    gridCols: { default: 3 },
    inputBtnProps: { default: () => ({}) },
    primaryBtn: { default: "social" },
    classes: { default: () => ({}) },
    isExistingLogin: { type: Boolean, default: !1 },
    existingLoginProps: { default: () => ({}) },
    existingLabelInline: { type: Boolean, default: !1 },
    divider: { type: Boolean, default: !1 }
  },
  emits: ["onSocialLoginClick", "onExistingLoginClick", "onInputBtnClick"],
  setup(e, { emit: i }) {
    const l = M(!1), d = ["apple", "github"], a = q();
    return (r, c) => {
      var b, f, v, y, h, k, C;
      return t(), n("div", {
        class: o(["w-full flex flex-col", (b = e.classes) == null ? void 0 : b.container])
      }, [
        e.isExistingLogin && ((f = e.existingLoginProps) != null && f.verifier) ? (t(), S(s(le), {
          key: 0,
          size: e.existingLabelInline ? "xl" : "md",
          pill: e.pill,
          class: o(["mb-4", (v = e.classes) == null ? void 0 : v.existingBtn]),
          onClick: c[0] || (c[0] = (g) => i("onExistingLoginClick", e.existingLoginProps))
        }, {
          default: O(() => {
            var g, p, I, T, D, w, E;
            return [
              (g = s(a)) != null && g.existingButton ? u("", !0) : (t(), n("div", Jt, [
                R(s(V), {
                  name: ((p = e.existingLoginProps) == null ? void 0 : p.icon) || "",
                  class: o(["w-6", ((I = e.existingLoginProps) == null ? void 0 : I.iconStyle) || ""]),
                  size: ((T = e.existingLoginProps) == null ? void 0 : T.iconSize) || "24"
                }, null, 8, ["name", "class", "size"]),
                m("p", {
                  class: o(["text-sm font-medium flex items-center gap-1", { "flex-col": e.existingLabelInline }])
                }, [
                  m("span", Xt, x(((D = e.existingLoginProps) == null ? void 0 : D.label) || "Continue With") + " " + x(((w = e.existingLoginProps) == null ? void 0 : w.verifier) || ""), 1),
                  e.existingLabelInline ? (t(), n("span", Yt, x(e.existingLoginProps.loginHint), 1)) : (t(), n("span", Qt, x(e.existingLoginProps.loginHint), 1))
                ], 2)
              ])),
              (E = s(a)) != null && E.existingButton ? $(r.$slots, "existingButton", { key: 1 }, void 0, !0) : u("", !0)
            ];
          }),
          _: 3
        }, 8, ["size", "pill", "class"])) : u("", !0),
        e.socialLogins.length > 0 ? (t(), n("div", {
          key: 1,
          class: o([
            "login-list overflow-y-hidden grid gap-4",
            { "login-list--expand": l.value, "grid-cols-3": e.gridCols === 3, "grid-cols-4": e.gridCols === 2 },
            (y = e.classes) == null ? void 0 : y.loginItemContainer
          ])
        }, [
          (t(!0), n(te, null, ae(e.socialLogins, (g, p) => {
            var I;
            return t(), S(s(le), {
              key: g.icon,
              class: o([
                "w-full !h-auto group py-3 rounded-full flex justify-center items-center",
                {
                  "col-span-3": !e.isExistingLogin && ((g == null ? void 0 : g.block) || p === 0),
                  "col-span-2": e.gridCols === 2,
                  "col-span-4": e.gridCols === 2 && ((g == null ? void 0 : g.block) || p === 0)
                },
                (I = e.classes) == null ? void 0 : I.loginItem
              ]),
              variant: !e.isExistingLogin && e.primaryBtn === "social" && p === 0 ? "primary" : (g == null ? void 0 : g.type) || "tertiary",
              type: "button",
              "aria-label": `${g.icon} Login Button`,
              pill: e.pill,
              onClick: (T) => i("onSocialLoginClick", g, p)
            }, {
              default: O(() => [
                m("img", {
                  class: "w-5 h-5 block dark:hidden group-hover:hidden",
                  src: `https://images.web3auth.io/login-${g == null ? void 0 : g.icon}-${!e.isExistingLogin && e.primaryBtn === "social" && p === 0 ? "light" : "dark"}.svg`,
                  alt: `${g.icon} Icon`
                }, null, 8, _t),
                m("img", {
                  class: "w-5 h-5 dark:block hidden group-hover:hidden",
                  src: `https://images.web3auth.io/login-${g == null ? void 0 : g.icon}-light.svg`,
                  alt: `${g == null ? void 0 : g.icon} Icon`
                }, null, 8, ea),
                m("img", {
                  class: "w-5 h-5 hidden group-hover:block",
                  src: `https://images.web3auth.io/login-${g == null ? void 0 : g.icon}-${d.includes((g == null ? void 0 : g.icon) || "") ? "light" : "active"}.svg`,
                  alt: `${g == null ? void 0 : g.icon} Icon`
                }, null, 8, la),
                g != null && g.description && !e.isExistingLogin ? (t(), n("div", {
                  key: 0,
                  class: o([
                    "flex flex-col items-center ml-2 dark:text-app-white text-app-gray-600",
                    { "text-app-white": !e.isExistingLogin && e.primaryBtn === "social" }
                  ])
                }, x(g == null ? void 0 : g.description), 3)) : u("", !0)
              ]),
              _: 2
            }, 1032, ["class", "variant", "aria-label", "pill", "onClick"]);
          }), 128))
        ], 2)) : u("", !0),
        e.socialLoginMessage ? (t(), n("p", {
          key: 2,
          class: o(["text-xs font-medium text-app-gray-500 dark:text-app-gray-200 mt-4", (h = e.classes) == null ? void 0 : h.socialLoginMsg])
        }, x(e.socialLoginMessage), 3)) : u("", !0),
        e.socialLogins.length > 0 && e.socialLogins.length > 4 ? (t(), n("div", {
          key: 3,
          class: o(["flex items-center justify-end my-4", { "my-2": e.divider }, (k = e.classes) == null ? void 0 : k.expandBtnContainer])
        }, [
          R(s(le), de({ variant: "text" }, e.inputExpandBtnProps, {
            class: ["text-sm font-medium", (C = e.classes) == null ? void 0 : C.expandBtn],
            onClick: c[1] || (c[1] = N((g) => l.value = !l.value, ["stop"]))
          }), {
            default: O(() => [
              Z(x(l.value ? e.collapseLabel : e.expandLabel), 1)
            ]),
            _: 1
          }, 16, ["class"])
        ], 2)) : u("", !0),
        e.divider ? (t(), n("div", ta, oa)) : u("", !0),
        $(r.$slots, "formBody", {}, void 0, !0),
        e.showInput ? (t(), n("div", da, [
          R(s(Ce), de(e.inputProps, { pill: e.pill }), null, 16, ["pill"]),
          R(s(le), de({ class: "my-4" }, e.inputBtnProps, {
            variant: !e.isExistingLogin && e.primaryBtn === "input" ? "primary" : "tertiary",
            pill: e.pill,
            block: "",
            onClick: c[2] || (c[2] = N((g) => i("onInputBtnClick"), ["stop"]))
          }), {
            default: O(() => [
              Z(x(e.inputBtnLabel), 1)
            ]),
            _: 1
          }, 16, ["variant", "pill"])
        ])) : u("", !0)
      ], 2);
    };
  }
});
const cn = /* @__PURE__ */ A(ia, [["__scopeId", "data-v-3333b0d9"]]), ca = (e) => (ge("data-v-2df21e98"), e = e(), xe(), e), ua = ["id", "aria-modal", "data-modal-placement", "onClick"], ra = /* @__PURE__ */ ca(() => /* @__PURE__ */ m("svg", {
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ m("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)), fa = [
  ra
], va = /* @__PURE__ */ z({
  __name: "Modal",
  props: {
    open: { type: Boolean, default: !1 },
    id: { default: "" },
    width: { default: "default" },
    placement: { default: "center" },
    headerDivider: { type: Boolean, default: !1 },
    footerDivider: { type: Boolean, default: !1 },
    borderRadius: { type: Boolean, default: !0 },
    border: { type: Boolean, default: !0 },
    clearIcon: { type: Boolean, default: !0 },
    shadow: { type: Boolean, default: !0 },
    classes: { default: () => ({}) },
    backdropClose: { type: Boolean, default: !0 },
    escapeClose: { type: Boolean, default: !0 }
  },
  emits: ["onClose"],
  setup(e, { emit: i }) {
    const l = e, d = () => {
      i("onClose", !1);
    }, a = q(), r = (b) => {
      var f;
      l.open && ((f = b == null ? void 0 : b.key) == null ? void 0 : f.toLowerCase()) === "escape" && d();
    };
    me(
      () => l.open,
      (b) => {
        l.escapeClose && (b ? document.addEventListener("keydown", r) : document.removeEventListener("keydown", r));
      }
    );
    const c = () => {
      l.backdropClose && d();
    };
    return (b, f) => {
      var v, y, h, k, C, g, p, I, T;
      return t(), n("div", {
        id: e.id,
        tabindex: "-1",
        role: "alertdialog",
        "aria-modal": e.open,
        "data-modal-placement": `modal-${e.placement}`,
        class: o([
          "fixed !z-50 w-full p-4 overflow-x-hidden overflow-y-auto h-modal modal !opacity-100 visible modal-container",
          `modal-${e.placement}`,
          { "!hidden": !e.open },
          (v = e.classes) == null ? void 0 : v.overlayContainer
        ]),
        "aria-hidden": "",
        onClick: N(c, ["self", "exact"])
      }, [
        m("div", {
          class: o([
            "relative h-full md:h-auto bg-app-white dark:bg-app-gray-700 pointer-events-auto",
            `modal-size-${e.width}`,
            { "rounded-lg": e.borderRadius, shadow: e.shadow, "border dark:border-app-gray-700": e.border },
            (y = e.classes) == null ? void 0 : y.modalContent
          ])
        }, [
          e.clearIcon ? (t(), n("button", {
            key: 0,
            type: "button",
            class: o([
              "absolute right-1 top-1 text-app-gray-400 bg-transparent hover:text-app-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:text-app-white",
              (h = e.classes) == null ? void 0 : h.clearIcon
            ]),
            "data-modal-hide": "staticModal",
            onClick: d
          }, fa, 2)) : u("", !0),
          (k = s(a)) != null && k.header ? (t(), n("div", {
            key: 1,
            class: o(["flex items-start justify-between px-6 py-4 dark:border-app-gray-600", { "border-b": e.headerDivider }, (C = e.classes) == null ? void 0 : C.header])
          }, [
            $(b.$slots, "header", {}, void 0, !0)
          ], 2)) : u("", !0),
          (g = s(a)) != null && g.body ? (t(), n("div", {
            key: 2,
            class: o(["px-6 py-4 space-y-6", (p = e.classes) == null ? void 0 : p.body])
          }, [
            $(b.$slots, "body", {}, void 0, !0)
          ], 2)) : u("", !0),
          (I = s(a)) != null && I.footer ? (t(), n("div", {
            key: 3,
            class: o([
              "flex items-center px-6 py-4 space-x-2 border-app-gray-200 dark:border-app-gray-600",
              { "border-t": e.footerDivider },
              (T = e.classes) == null ? void 0 : T.footer
            ])
          }, [
            $(b.$slots, "footer", {}, void 0, !0)
          ], 2)) : u("", !0)
        ], 2)
      ], 10, ua);
    };
  }
});
const un = /* @__PURE__ */ A(va, [["__scopeId", "data-v-2df21e98"]]), ba = (e) => (ge("data-v-105119af"), e = e(), xe(), e), ma = ["href"], ya = ["src"], ha = /* @__PURE__ */ ba(() => /* @__PURE__ */ m("span", { class: "sr-only" }, "Open main menu", -1)), ga = ["href"], xa = /* @__PURE__ */ z({
  __name: "Navbar",
  props: {
    logo: { default: () => ({ src: "", link: "" }) },
    title: { default: "" },
    border: { type: Boolean, default: !1 },
    rounded: { type: Boolean, default: !1 },
    showMobileMenuIcon: { type: Boolean, default: !0 },
    menuItems: { default: () => [] },
    menuIcon: { default: "menu-icon" },
    classes: { default: () => ({}) }
  },
  emits: ["onMenuIconClick", "onMenuItemClick"],
  setup(e, { emit: i }) {
    const l = q();
    return (d, a) => {
      var r, c, b, f, v, y, h, k, C, g, p, I;
      return t(), n("nav", {
        class: o(["navbar-container", { border: e.border, "rounded-lg": e.rounded }, (r = e.classes) == null ? void 0 : r.navContainer])
      }, [
        m("div", {
          class: o(["flex flex-wrap items-center justify-between", (c = e.classes) == null ? void 0 : c.container])
        }, [
          !s(l).navLogo && ((b = e.logo) != null && b.src) ? (t(), n("a", {
            key: 0,
            href: ((f = e.logo) == null ? void 0 : f.link) || "",
            class: "flex items-center"
          }, [
            (v = e.logo) != null && v.src ? (t(), n("img", {
              key: 0,
              src: (y = e.logo) == null ? void 0 : y.src,
              class: o(["h-6 mr-3 sm:h-9", (h = e.classes) == null ? void 0 : h.logo]),
              alt: "Logo"
            }, null, 10, ya)) : u("", !0),
            e.title ? (t(), n("span", {
              key: 1,
              class: o(["self-center text-xl font-semibold whitespace-nowrap dark:text-white", (k = e.classes) == null ? void 0 : k.title])
            }, x(e.title), 3)) : u("", !0)
          ], 8, ma)) : u("", !0),
          s(l).navLogo ? $(d.$slots, "navLogo", { key: 1 }, void 0, !0) : u("", !0),
          !s(l).menuIcon && e.showMobileMenuIcon ? (t(), n("button", {
            key: 2,
            "data-collapse-toggle": "navbar-default",
            type: "button",
            class: o(["menuIcon", (C = e.classes) == null ? void 0 : C.menuIcon]),
            "aria-controls": "navbar-default",
            "aria-expanded": "false",
            onClick: a[0] || (a[0] = (T) => i("onMenuIconClick"))
          }, [
            ha,
            R(s(V), { name: e.menuIcon }, null, 8, ["name"])
          ], 2)) : u("", !0),
          s(l).menuIcon && e.showMobileMenuIcon ? $(d.$slots, "menuIcon", { key: 3 }, void 0, !0) : u("", !0),
          m("div", {
            class: o(["hidden w-full md:block md:w-auto", (g = e.classes) == null ? void 0 : g.menuContainer])
          }, [
            !s(l).menu && e.menuItems && ((p = e.menuItems) == null ? void 0 : p.length) > 0 ? (t(), n("ul", {
              key: 0,
              class: o(["navbar-item-container", (I = e.classes) == null ? void 0 : I.menuItemContainer])
            }, [
              (t(!0), n(te, null, ae(e.menuItems, (T) => {
                var D;
                return t(), n("li", {
                  key: T.name
                }, [
                  m("a", {
                    href: T.link,
                    class: o([
                      "navbar-item",
                      { "md:!text-app-primary-600 dark:md:!text-app-primary-500": T.active },
                      T != null && T.disabled ? "cursor-not-allowed" : "cursor-pointer",
                      (D = e.classes) == null ? void 0 : D.item
                    ]),
                    "aria-current": "page"
                  }, x(T.name), 11, ga)
                ]);
              }), 128))
            ], 2)) : u("", !0),
            s(l).menu ? $(d.$slots, "menu", { key: 1 }, void 0, !0) : u("", !0)
          ], 2)
        ], 2)
      ], 2);
    };
  }
});
const rn = /* @__PURE__ */ A(xa, [["__scopeId", "data-v-105119af"]]), ka = { key: 0 }, wa = { key: 1 }, $a = ["onClick"], pa = { key: 0 }, Ca = { key: 1 }, Ia = { class: "font-semibold text-gray-900 dark:text-white" }, Ba = { class: "font-semibold text-gray-900 dark:text-white" }, Ta = { class: "font-semibold text-gray-900 dark:text-white" }, La = {
  class: /* @__PURE__ */ o(["inline-flex mt-2 xs:mt-0"])
}, Sa = { key: 0 }, za = { key: 1 }, Pa = { key: 0 }, Da = { key: 1 }, Va = /* @__PURE__ */ z({
  __name: "Pagination",
  props: {
    type: { default: "table" },
    prevLabel: { default: "Previous" },
    nextLabel: { default: "Next" },
    to: { default: 0 },
    from: { default: 6 },
    current: { default: 3 },
    total: { default: 6 },
    classes: { default: () => ({}) }
  },
  emits: ["onClick", "onPrev", "onNext"],
  setup(e, { emit: i }) {
    const l = q();
    return (d, a) => {
      var r, c, b, f, v, y, h, k, C;
      return t(), n("div", {
        class: o([(r = e.classes) == null ? void 0 : r.root])
      }, [
        e.type === "default" ? (t(), n("nav", {
          key: 0,
          "aria-label": "Pagination",
          class: o(["w-fit", (c = e.classes) == null ? void 0 : c.container])
        }, [
          m("ul", {
            class: o(["inline-flex -space-x-px", (b = e.classes) == null ? void 0 : b.itemContainer])
          }, [
            m("li", null, [
              m("div", {
                "aria-hidden": "",
                class: o(["page-item rounded-l-lg", (f = e.classes) == null ? void 0 : f.prevItem]),
                onClick: a[0] || (a[0] = (g) => i("onPrev"))
              }, [
                s(l).prev ? u("", !0) : (t(), n("span", ka, x(e.prevLabel), 1)),
                s(l).prev ? (t(), n("span", wa, [
                  $(d.$slots, "prev", {}, void 0, !0)
                ])) : u("", !0)
              ], 2)
            ]),
            (t(!0), n(te, null, ae(Array.from({ length: e.from }, (g, p) => p), (g, p) => {
              var I, T;
              return t(), n("li", {
                key: p,
                "aria-hidden": "",
                onClick: (D) => i("onClick", p + 1)
              }, [
                m("div", {
                  class: o(["page-item", { "page-current": e.current === p + 1 }, (I = e.classes) == null ? void 0 : I.item, e.current === p + 1 && ((T = e.classes) == null ? void 0 : T.currentItem)])
                }, x(p + 1), 3)
              ], 8, $a);
            }), 128)),
            m("li", null, [
              m("div", {
                "aria-hidden": "",
                class: o(["page-item rounded-r-lg", (v = e.classes) == null ? void 0 : v.nextItem]),
                onClick: a[1] || (a[1] = (g) => i("onNext"))
              }, [
                s(l).next ? u("", !0) : (t(), n("span", pa, x(e.nextLabel), 1)),
                s(l).next ? (t(), n("span", Ca, [
                  $(d.$slots, "next", {}, void 0, !0)
                ])) : u("", !0)
              ], 2)
            ])
          ], 2)
        ], 2)) : u("", !0),
        e.type === "table" ? (t(), n("div", {
          key: 1,
          class: o(["flex flex-col items-center w-fit", (y = e.classes) == null ? void 0 : y.container])
        }, [
          m("span", {
            class: o(["text-sm text-gray-700 dark:text-gray-400", (h = e.classes) == null ? void 0 : h.tableText])
          }, [
            Z(" Showing "),
            m("span", Ia, x(e.to + 1), 1),
            Z(" to "),
            m("span", Ba, x(e.from), 1),
            Z(" of "),
            m("span", Ta, x(e.total), 1),
            Z(" Entries ")
          ], 2),
          m("div", La, [
            m("button", {
              type: "button",
              class: o(["table-item rounded-l", (k = e.classes) == null ? void 0 : k.prevItem]),
              onClick: a[2] || (a[2] = (g) => i("onPrev"))
            }, [
              s(l).prev ? u("", !0) : (t(), n("span", Sa, x(e.prevLabel), 1)),
              s(l).prev ? (t(), n("span", za, [
                $(d.$slots, "prev", {}, void 0, !0)
              ])) : u("", !0)
            ], 2),
            m("button", {
              type: "button",
              class: o(["table-item rounded-r", (C = e.classes) == null ? void 0 : C.nextItem]),
              onClick: a[3] || (a[3] = (g) => i("onNext"))
            }, [
              s(l).next ? u("", !0) : (t(), n("span", Pa, x(e.nextLabel), 1)),
              s(l).next ? (t(), n("span", Da, [
                $(d.$slots, "next", {}, void 0, !0)
              ])) : u("", !0)
            ], 2)
          ])
        ], 2)) : u("", !0)
      ], 2);
    };
  }
});
const fn = /* @__PURE__ */ A(Va, [["__scopeId", "data-v-d69d8240"]]), vn = /* @__PURE__ */ z({
  __name: "ProgressBar",
  props: {
    value: { default: 0 },
    variant: { default: "default" },
    size: { default: "default" },
    label: { default: "" },
    unit: { default: "%" },
    showValue: { type: Boolean },
    classes: { default: () => ({}) }
  },
  setup(e) {
    const i = e, l = P(() => {
      let a = "";
      return i.variant === "default" ? a = "bg-app-gray-900 dark:bg-app-gray-500" : i.variant === "success" ? a = "bg-app-green-400" : i.variant === "danger" ? a = "bg-app-red-500" : i.variant === "warning" ? a = "bg-app-yellow-300" : a = "bg-app-primary-600", a;
    }), d = P(() => {
      let a = "";
      return i.size === "default" ? a = "h-2.5" : i.size === "small" ? a = "h-1.5" : i.size === "large" ? a = "h-4" : a = "h-6", a;
    });
    return (a, r) => {
      var c, b, f, v, y, h;
      return t(), n("div", {
        class: o(["flex-col", (c = e.classes) == null ? void 0 : c.container])
      }, [
        m("div", {
          class: o([
            "flex mb-1",
            { "justify-between": e.label && e.showValue, "justify-start": e.label && !e.showValue, "justify-end": !e.label && e.showValue },
            (b = e.classes) == null ? void 0 : b.labelContainer
          ])
        }, [
          e.label ? (t(), n("span", {
            key: 0,
            class: o(["text-xs font-medium text-app-gray-500 dark:text-app-white", (f = e.classes) == null ? void 0 : f.label])
          }, x(e.label), 3)) : u("", !0),
          e.showValue ? (t(), n("span", {
            key: 1,
            class: o(["text-xs font-medium text-app-gray-500 dark:text-app-white", (v = e.classes) == null ? void 0 : v.value])
          }, x(`${e.value} ${e.unit}`), 3)) : u("", !0)
        ], 2),
        m("div", {
          class: o(["w-full bg-app-gray-200 rounded-full dark:bg-app-gray-700", s(d), (y = e.classes) == null ? void 0 : y.outerBar])
        }, [
          m("div", {
            class: o(["h-full rounded-full", s(l), (h = e.classes) == null ? void 0 : h.innerBar]),
            style: oe(`width: ${e.value}%`)
          }, null, 6)
        ], 2)
      ], 2);
    };
  }
}), Aa = ["id", "value", "disabled", "checked"], Ma = ["for"], Fa = {
  key: 0,
  class: "text-xs text-app-gray-500 dark:text-app-gray-400"
}, Ea = ["for"], Na = /* @__PURE__ */ z({
  __name: "Radio",
  props: {
    label: { default: "" },
    description: { default: "" },
    id: { default: "" },
    value: { default: "" },
    checked: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    labelPlacement: { default: "right" },
    classes: { default: () => ({}) }
  },
  emits: ["onChange", "update:value"],
  setup(e, { emit: i }) {
    const l = q(), d = (a) => {
      var c;
      const r = (c = a == null ? void 0 : a.target) == null ? void 0 : c.value;
      i("onChange", r, a), i("update:value", r);
    };
    return (a, r) => {
      var c, b, f, v, y;
      return t(), n("div", {
        class: o(["flex items-center mb-4 w-fit gap-2", `radio-label-${e.labelPlacement}`, a.$attrs.class, (c = e.classes) == null ? void 0 : c.container])
      }, [
        m("input", de({
          id: e.id,
          value: e.value,
          type: "radio",
          class: "radio",
          disabled: e.disabled,
          checked: e.checked
        }, { ...a.$attrs, class: "", style: {} }, { onChange: d }), null, 16, Aa),
        e.label && !((b = s(l)) != null && b.radioLabel) ? (t(), n("label", {
          key: 0,
          "aria-hidden": "",
          for: e.id,
          class: o(["radio-label flex flex-col", { "!text-app-gray-400 !cursor-not-allowed": e.disabled }, (f = e.classes) == null ? void 0 : f.label, e.disabled && ((v = e.classes) == null ? void 0 : v.disabled)])
        }, [
          m("span", null, x(e.label), 1),
          e.description ? (t(), n("span", Fa, x(e.description), 1)) : u("", !0)
        ], 10, Ma)) : u("", !0),
        (y = s(l)) != null && y.radioLabel ? (t(), n("label", {
          key: 1,
          for: e.id
        }, [
          $(a.$slots, "radioLabel", {}, void 0, !0)
        ], 8, Ea)) : u("", !0)
      ], 2);
    };
  }
});
const Oa = /* @__PURE__ */ A(Na, [["__scopeId", "data-v-3053d152"]]), bn = /* @__PURE__ */ z({
  __name: "RadioGroup",
  props: {
    items: { default: () => [] },
    modelValue: { default: "" },
    disabledAll: { type: Boolean, default: !1 },
    labelPlacement: { default: "right" },
    row: { type: Boolean, default: !1 },
    classes: { default: () => ({}) },
    radioClasses: { default: () => ({}) }
  },
  emits: ["onChange", "update:modelValue"],
  setup(e, { emit: i }) {
    const l = e, d = (r) => {
      i("update:modelValue", r), i("onChange", r);
    }, a = M(l.modelValue);
    return me(
      () => l.modelValue,
      () => {
        a.value = l.modelValue;
      }
    ), (r, c) => {
      var b;
      return t(), n("div", {
        class: o(["flex flex-col gap-1", { "!flex-row !gap-4": e.row }, (b = e.classes) == null ? void 0 : b.container])
      }, [
        (t(!0), n(te, null, ae(e.items, (f, v) => (t(), S(s(Oa), {
          id: f.id,
          key: f.label,
          label: f.label,
          value: f.value,
          description: f.description,
          checked: a.value === f.value,
          disabled: e.disabledAll || f.disabled,
          "label-placement": e.labelPlacement,
          "tab-index": v,
          classes: { ...e.radioClasses },
          onOnChange: d
        }, null, 8, ["id", "label", "value", "description", "checked", "disabled", "label-placement", "tab-index", "classes"]))), 128))
      ], 2);
    };
  }
}), ja = {
  key: 0,
  class: "flex flex-1 items-center gap-1 mr-2"
}, Ra = {
  key: 1,
  class: "w-max"
}, Ua = { class: "flex gap-1" }, Ka = ["onClick"], Ga = ["onClick"], Ha = ["aria-selected", "onClick", "onKeydown"], Wa = { key: 1 }, Za = { key: 2 }, qa = ["src", "alt"], Ja = { class: "flex flex-col flex-1" }, Xa = /* @__PURE__ */ z({
  __name: "Select",
  props: {
    size: { default: "medium" },
    options: { default: () => [] },
    iconPlacement: { default: "left" },
    label: { default: "" },
    placeholder: { default: "" },
    modelValue: { default: "" },
    multiple: { type: Boolean },
    error: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    id: { default: "" },
    helperText: { default: "" },
    trailingIcon: { default: "" },
    endIcon: { default: "" },
    classes: { default: () => ({}) },
    inputClasses: { default: () => ({}) },
    toolTipIcon: { default: "information-circle-icon" },
    showToolTipIcon: { type: Boolean, default: !1 },
    allowFilter: { type: Boolean, default: !0 },
    inputProps: { default: () => ({}) },
    filterProps: { default: () => ({}) },
    showMultipleFilter: { type: Boolean, default: !0 },
    filterPlaceholder: { default: "Search..." },
    showClearAllIcon: { type: Boolean, default: !1 },
    showSelectAllIcon: { type: Boolean, default: !1 },
    customFilter: { type: Function, default: () => [] },
    fixedPlaceholder: { default: "" },
    showCheckBox: { type: Boolean, default: !1 },
    disableDeselect: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "onTrailingIconClick", "onEndIconClick", "onTooltipClick", "onSelect"],
  setup(e, { emit: i }) {
    const l = e, d = Qe(l, "modelValue"), a = M(!1), r = M(""), c = M([]), b = M([]), f = M([]), v = M(-1), y = M([]), h = M(-1), k = M(l.options), C = M(null), g = M(""), p = P(() => new Set(c.value)), I = P(() => new Set(y.value)), T = P(() => new Set(b.value)), D = P(() => new Set(f.value)), w = (B) => {
      var L;
      !l.multiple && typeof d.value == "string" && (r.value = ((L = l.options.find((F) => F.value.toLowerCase() === d.value.toLowerCase())) == null ? void 0 : L.name) || "", h.value = l.options.findIndex(
        (F) => F.value.toLowerCase() === d.value.toLowerCase()
      )), Array.isArray(d.value) && l.multiple && (B && (c.value = [], f.value = [], b.value = []), y.value = l.options.map((F, Y) => Array.isArray(d.value) && d.value.find((G) => G.toLowerCase().includes(F.value.toLowerCase())) ? (c.value.push(F.name), f.value.push(F), b.value.push(F.value), Y) : -1));
    };
    Re(() => w());
    function E() {
      l.disabled || (a.value = !a.value, i("onEndIconClick", a.value));
    }
    const j = () => {
      a.value = !1, v.value = -1, h.value = -1;
    }, H = (B, L) => {
      const { name: F, value: Y } = B;
      p.value.has(F) ? (p.value.delete(F), I.value.delete(L), T.value.delete(Y), D.value.forEach((G) => {
        G.name === F && D.value.delete(G);
      }), c.value = [...p.value], y.value = [...I.value], b.value = [...T.value], f.value = [...D.value]) : (c.value.push(B.name), b.value.push(B.value), y.value.push(L), f.value.push(B)), i("onSelect", f.value), i("update:modelValue", b.value);
    }, J = (B, L) => {
      l.disableDeselect || r.value.toLowerCase() !== B.name.toLowerCase() ? (r.value = B.name, h.value = L, i("onSelect", B), i("update:modelValue", B.value)) : (r.value = "", h.value = -1, i("onSelect", ""), i("update:modelValue", ""));
    };
    function U(B, L) {
      l.multiple ? H(B, L) : (J(B, L), a.value = !1), v.value = -1;
    }
    function W() {
      const B = document.getElementById("menu-container");
      if (!B)
        return;
      const { top: L, bottom: F } = B.getBoundingClientRect(), Y = B.children[v.value];
      if (!Y)
        return;
      const { top: G, bottom: be } = Y.getBoundingClientRect();
      G < L ? B.scrollTop -= L - G : be > F && (B.scrollTop += be - F);
    }
    function Q() {
      a.value = !0, v.value < k.value.length - 1 && (v.value += 1), W();
    }
    function _() {
      a.value = !0, v.value > 0 && (v.value -= 1), W();
    }
    const K = () => {
      const B = k.value[v.value], { name: L, value: F } = B;
      p.value.has(L) ? (p.value.delete(L), I.value.delete(v.value), T.value.delete(F), D.value.forEach((Y) => {
        Y.name === F && D.value.delete(Y);
      }), c.value = [...p.value], y.value = [...I.value], b.value = [...T.value], f.value = [...D.value]) : (c.value.push(L), b.value.push(F), f.value.push(B), y.value.push(v.value)), i("onSelect", f.value), i("update:modelValue", b.value);
    }, X = () => {
      const B = k.value[v.value];
      if (l.disableDeselect || r.value.toLowerCase() !== B.name.toLowerCase()) {
        r.value = B.name;
        const L = v.value;
        h.value = L, v.value = L, i("onSelect", B), i("update:modelValue", B.value);
      } else
        r.value = "", h.value = -1, i("onSelect", ""), i("update:modelValue", "");
    };
    function ue() {
      v.value !== -1 && (l.multiple ? K() : (X(), a.value = !1));
    }
    function ie(B) {
      if (l.allowFilter && !l.multiple) {
        const { value: L } = B.target;
        a.value = !0, v.value = -1, L !== "" ? k.value = (l == null ? void 0 : l.customFilter(l.options).length) > 0 ? l == null ? void 0 : l.customFilter(l.options) : l.options.filter((F) => F.name.toLowerCase().includes(L.toLowerCase())) : k.value = l.options;
      }
    }
    function ce() {
      g.value !== "" ? k.value = (l == null ? void 0 : l.customFilter(l.options).length) > 0 ? l == null ? void 0 : l.customFilter(l.options) : l.options.filter((B) => B.name.toLowerCase().includes(g.value.toLowerCase())) : k.value = l.options;
    }
    const se = q(), re = P(() => l.multiple ? c.value.length > 3 ? `${c.value.slice(0, 3).join(", ")}, +${c.value.length - 3}...` : c.value.join(", ") : r.value), we = () => {
      l.multiple ? (c.value.length = 0, y.value.length = 0, b.value.length = 0, f.value.length = 0) : (r.value = "", h.value = -1), v.value = -1, a.value = !1, k.value = l.options, i("onSelect", l.multiple ? [] : ""), i("update:modelValue", l.multiple ? [] : "");
    }, $e = () => {
      const B = [], L = [], F = [];
      k.value.forEach((Y, G) => {
        B.push(Y.name), L.push(G), F.push(Y.value);
      }), c.value = B, y.value = L, b.value = F, v.value = -1, i("onSelect", k.value), i("update:modelValue", b.value);
    }, ke = (B) => {
      (B.target.tagName.toLowerCase() === "label" || C.value && !C.value.contains(B.target)) && (a.value = !1);
    };
    return me(
      () => a.value,
      (B) => {
        B ? document.addEventListener("click", ke) : document.removeEventListener("click", ke);
      }
    ), me(
      () => d.value,
      () => {
        w(!0);
      }
    ), me(
      () => l.options,
      () => {
        k.value = l.options;
      }
    ), (B, L) => {
      var F, Y;
      return t(), n("div", {
        ref_key: "torusSelect",
        ref: C,
        class: o(["relative inline-block w-full", (F = e.classes) == null ? void 0 : F.container])
      }, [
        R(s(Ce), de({
          id: e.id,
          modelValue: s(re),
          "onUpdate:modelValue": L[1] || (L[1] = (G) => ye(re) ? re.value = G : null),
          "aria-labelledby": e.label,
          label: e.label,
          disabled: e.disabled,
          size: e.size,
          placeholder: e.placeholder,
          error: e.error,
          success: e.success,
          "show-tool-tip-icon": e.showToolTipIcon,
          classes: {
            endIcon: `${e.disabled ? "!text-app-gray-400 !cursor-not-allowed" : ""}`,
            inputContainer: "cursor-pointer",
            input: "cursor-pointer",
            ...e.inputClasses
          },
          readonly: e.multiple ? e.multiple : !e.allowFilter
        }, { ...e.inputProps, helperText: "", class: "" }, {
          onOnTooltipClick: L[2] || (L[2] = (G) => i("onTooltipClick")),
          onKeydown: [
            ne(N(E, ["exact", "stop", "prevent"]), ["space"]),
            ne(N(j, ["exact"]), ["esc"]),
            ne(N(Q, ["exact", "stop"]), ["arrow-down"]),
            ne(N(_, ["exact", "stop"]), ["arrow-up"]),
            ne(N(ue, ["exact", "stop"]), ["enter"])
          ],
          onInput: ie,
          onFocus: L[3] || (L[3] = (G) => a.value = !0),
          onDblclick: L[4] || (L[4] = (G) => a.value = !1)
        }), {
          trailingIconSlot: O(() => [
            e.trailingIcon || e.fixedPlaceholder ? (t(), n("div", ja, [
              e.trailingIcon ? (t(), S(s(V), {
                key: 0,
                name: e.trailingIcon,
                onClick: L[0] || (L[0] = N((G) => i("onTrailingIconClick"), ["stop"]))
              }, null, 8, ["name"])) : u("", !0),
              e.fixedPlaceholder ? (t(), n("p", Ra, x(e.fixedPlaceholder), 1)) : u("", !0)
            ])) : u("", !0)
          ]),
          endIconSlot: O(() => {
            var G, be;
            return [
              m("div", Ua, [
                m("span", {
                  "aria-hidden": "",
                  title: "Clear All Selected Items",
                  onClick: N(we, ["stop"])
                }, [
                  e.showClearAllIcon && ((G = s(se)) != null && G.options ? l.modelValue : r.value || c.value.length > 0) ? (t(), S(s(V), {
                    key: 0,
                    name: "x-circle-solid-icon",
                    class: "cursor-pointer"
                  })) : u("", !0)
                ], 8, Ka),
                m("span", {
                  "aria-hidden": "",
                  title: "Select All Selected Items",
                  onClick: N($e, ["stop"])
                }, [
                  e.multiple && e.showSelectAllIcon && !((be = s(se)) != null && be.options) ? (t(), S(s(V), {
                    key: 0,
                    name: "check-circle-solid-icon",
                    class: "cursor-pointer"
                  })) : u("", !0)
                ], 8, Ga),
                R(s(V), {
                  name: e.endIcon || `chevron-${a.value ? "up" : "down"}-solid-icon`,
                  onClick: N(E, ["stop"])
                }, null, 8, ["name", "onClick"])
              ])
            ];
          }),
          _: 1
        }, 16, ["id", "modelValue", "aria-labelledby", "label", "disabled", "size", "placeholder", "error", "success", "show-tool-tip-icon", "classes", "readonly", "onKeydown"]),
        R(Ke, { name: "select-fade" }, {
          default: O(() => {
            var G, be, Te, Le, Se;
            return [
              ve(m("div", {
                class: o([
                  "z-10 absolute mt-2 left-0 w-full h-auto p-2 border border-app-gray-200 rounded-md bg-app-white shadow-xl text-app-gray-900 dark:bg-app-gray-700 dark:border-app-gray-600 dark:text-app-white",
                  (G = e.classes) == null ? void 0 : G.optionContainer
                ])
              }, [
                e.multiple && e.showMultipleFilter ? (t(), S(s(Ce), de({
                  key: 0,
                  modelValue: g.value,
                  "onUpdate:modelValue": L[5] || (L[5] = (ee) => g.value = ee),
                  "aria-labelledby": "filter",
                  size: "small",
                  placeholder: e.filterPlaceholder,
                  class: ["mb-4", (be = e.classes) == null ? void 0 : be.multipleFilter]
                }, e.filterProps, {
                  onInput: ce,
                  onKeydown: [
                    ne(N(Q, ["exact", "stop"]), ["arrow-down"]),
                    ne(N(_, ["exact", "stop"]), ["arrow-up"]),
                    ne(N(ue, ["exact", "stop"]), ["enter"])
                  ]
                }), null, 16, ["modelValue", "placeholder", "class", "onKeydown"])) : u("", !0),
                !((Te = s(se)) != null && Te.options) && k.value && k.value.length > 0 ? (t(), n("div", {
                  key: 1,
                  id: "menu-container",
                  class: o(["max-h-[248px] overflow-y-auto", (Le = e.classes) == null ? void 0 : Le.itemContainer])
                }, [
                  (t(!0), n(te, null, ae(k.value, (ee, fe) => {
                    var ze, Pe, De, Ve, Ae, Me, Fe;
                    return t(), n("div", {
                      key: ee.name,
                      class: o([
                        "flex items-center gap-4 px-4 py-2 cursor-pointer hover:bg-app-gray-300 text-app-gray-900 dark:text-app-white dark:hover:bg-app-gray-600 rounded-lg",
                        {
                          "!bg-app-gray-300 dark:!bg-app-gray-600": v.value === fe,
                          "flex-row": e.iconPlacement === "left",
                          "flex-row-reverse": e.iconPlacement === "right",
                          "mb-2": fe !== k.value.length - 1
                        },
                        l.multiple && y.value.includes(fe) && (((ze = e.classes) == null ? void 0 : ze.activeItem) || "!text-app-primary-600 dark:!text-app-white dark:!bg-app-gray-500 !bg-app-gray-100"),
                        !l.multiple && h.value === fe && (((Pe = e.classes) == null ? void 0 : Pe.activeItem) || "!text-app-primary-600 dark:!text-app-white dark:!bg-app-gray-500 !bg-app-gray-100"),
                        (De = e.classes) == null ? void 0 : De.option
                      ]),
                      "aria-hidden": "",
                      "aria-selected": e.multiple ? y.value.includes(fe) : h.value === fe,
                      role: "option",
                      onClick: (Rs) => U(ee, fe),
                      onKeydown: ne(N(j, ["exact"]), ["esc"])
                    }, [
                      e.showCheckBox ? (t(), S(s(We), {
                        key: 0,
                        id: ee.name,
                        value: ee.name,
                        checked: e.multiple ? y.value.includes(fe) : h.value === fe
                      }, null, 8, ["id", "value", "checked"])) : u("", !0),
                      ee.icon ? (t(), n("div", Wa, [
                        R(s(V), {
                          name: ee.icon,
                          size: "20",
                          class: o(["w-5", ((Ve = e.classes) == null ? void 0 : Ve.optionIcon) || ""])
                        }, null, 8, ["name", "class"])
                      ])) : u("", !0),
                      ee.imgSrc ? (t(), n("div", Za, [
                        m("img", {
                          src: ee.imgSrc,
                          alt: ee.name,
                          class: o(["w-7 h-5", (Ae = e.classes) == null ? void 0 : Ae.optionImg])
                        }, null, 10, qa)
                      ])) : u("", !0),
                      m("div", Ja, [
                        m("span", {
                          class: o(["text-base font-normal", (Me = e.classes) == null ? void 0 : Me.optionName])
                        }, x(ee.name), 3),
                        ee.description ? (t(), n("span", {
                          key: 0,
                          class: o(["text-xs font-normal text-app-gray-500 dark:text-app-gray-300", (Fe = e.classes) == null ? void 0 : Fe.optionDesc])
                        }, x(ee.description), 3)) : u("", !0)
                      ])
                    ], 42, Ha);
                  }), 128))
                ], 2)) : u("", !0),
                (Se = s(se)) != null && Se.options ? $(B.$slots, "options", {
                  key: 2,
                  selectOption: U,
                  options: k.value
                }, void 0, !0) : u("", !0)
              ], 2), [
                [pe, a.value]
              ])
            ];
          }),
          _: 3
        }),
        e.helperText ? (t(), n("p", {
          key: 0,
          class: o([
            "text-xs font-normal mt-1",
            e.success && !e.disabled ? "success-msg" : e.error && !e.disabled ? "error-msg" : "default-msg",
            (Y = e.classes) == null ? void 0 : Y.helperText
          ])
        }, x(e.helperText), 3)) : u("", !0)
      ], 2);
    };
  }
});
const mn = /* @__PURE__ */ A(Xa, [["__scopeId", "data-v-4e39b415"]]), Qa = { role: "status" }, Ya = /* @__PURE__ */ m("path", {
  d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
  fill: "currentColor"
}, null, -1), _a = /* @__PURE__ */ m("path", {
  d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
  fill: "currentFill"
}, null, -1), es = [
  Ya,
  _a
], ls = /* @__PURE__ */ m("span", { class: "sr-only" }, "Loading...", -1), yn = /* @__PURE__ */ z({
  __name: "Spinner",
  props: {
    variant: { default: "default" },
    size: { default: "default" },
    position: { default: "center" },
    classes: { default: () => ({}) }
  },
  setup(e) {
    const i = e, l = P(() => {
      let a = "";
      return i.variant === "default" ? a = "fill-app-gray-900 dark:fill-app-gray-500" : i.variant === "success" ? a = "fill-app-green-400" : i.variant === "danger" ? a = "fill-app-red-500" : i.variant === "warning" ? a = "fill-app-yellow-300" : a = "fill-app-primary-600", a;
    }), d = P(() => {
      let a = "";
      return i.size === "default" ? a = "w-6 h-6" : i.size === "small" ? a = "w-4 h-4" : i.size === "large" ? a = "w-8 h-8" : a = "w-10 h-10", a;
    });
    return (a, r) => {
      var c;
      return t(), n("div", {
        class: o([`flex justify-${e.position}`, (c = e.classes) == null ? void 0 : c.container])
      }, [
        m("div", Qa, [
          (t(), n("svg", {
            "aria-hidden": "true",
            class: o(["mr-2 text-gray-200 animate-spin dark:text-gray-600", s(l), s(d)]),
            viewBox: "0 0 100 101",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, es, 2)),
          ls
        ])
      ], 2);
    };
  }
}), ts = ["id", "aria-selected", "aria-controls"], as = /* @__PURE__ */ z({
  __name: "Tab",
  props: {
    id: { default: "" },
    variant: { default: "underline" },
    active: { type: Boolean, default: !1 },
    href: { default: "" },
    component: { default: "div" },
    borderRightRadius: { type: Boolean, default: !1 },
    borderLeftRadius: { type: Boolean, default: !1 },
    classes: { default: () => ({}) },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["onClick"],
  setup(e, { emit: i }) {
    const l = e, d = P(() => l.href ? "a" : l.component);
    return (a, r) => {
      var c, b, f, v, y;
      return t(), n("li", {
        id: e.id,
        role: "tab",
        "aria-selected": e.active,
        "aria-controls": e.id,
        class: o(["tab-container", { "tab-underline-border": e.variant === "underline" }, (c = e.classes) == null ? void 0 : c.container])
      }, [
        (t(), S(he(s(d)), {
          href: e.disabled ? "" : e.href,
          class: o([
            "text-sm font-medium flex items-center justify-center",
            e.active ? ((b = e.classes) == null ? void 0 : b.active) || `tab-active-${e.variant}` : ((f = e.classes) == null ? void 0 : f.inactive) || `tab-inactive-${e.variant}`,
            { "rounded-r-lg": e.variant === "full-width" && e.borderRightRadius, "rounded-l-lg": e.variant === "full-width" && e.borderLeftRadius },
            (v = e.classes) == null ? void 0 : v.component,
            { "tab-disabled": e.disabled }
          ]),
          onClick: r[0] || (r[0] = (h) => !e.href && !e.disabled && i("onClick"))
        }, {
          default: O(() => [
            $(a.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["href", "class"])),
        e.variant === "underline" && e.active ? (t(), n("div", {
          key: 0,
          class: o(["absolute -bottom-px w-10/12 h-px bg-app-primary-600", (y = e.classes) == null ? void 0 : y.underlineActive])
        }, null, 2)) : u("", !0)
      ], 10, ts);
    };
  }
});
const hn = /* @__PURE__ */ A(as, [["__scopeId", "data-v-049cfd61"]]), ss = ["id"], gn = /* @__PURE__ */ z({
  __name: "Tabs",
  props: {
    id: { default: "" },
    component: { default: "ul" },
    classes: { default: () => ({}) }
  },
  setup(e) {
    const i = e, l = P(() => i.component);
    return (d, a) => {
      var r, c;
      return t(), n("div", {
        id: e.id,
        class: o(["text-sm font-medium text-center", (r = e.classes) == null ? void 0 : r.container])
      }, [
        (t(), S(he(s(l)), {
          class: o(["flex flex-wrap -mb-px", (c = e.classes) == null ? void 0 : c.componentContainer])
        }, {
          default: O(() => [
            $(d.$slots, "default")
          ]),
          _: 3
        }, 8, ["class"]))
      ], 10, ss);
    };
  }
}), xn = /* @__PURE__ */ z({
  __name: "Tag",
  props: {
    minWidth: { default: "inherit" },
    color: { default: "#D9D7D5" }
  },
  setup(e) {
    return (i, l) => (t(), n("div", {
      class: "rounded-xl inline-flex items-center text-xs font-medium py-1 px-4",
      style: oe({ minWidth: e.minWidth, backgroundColor: e.color })
    }, [
      $(i.$slots, "default")
    ], 4));
  }
}), ns = ["for"], os = ["for"], ds = {
  class: /* @__PURE__ */ o(["flex-col"])
}, is = ["id", "aria-placeholder", "aria-labelledby", "disabled", "placeholder"], cs = /* @__PURE__ */ z({
  __name: "TextArea",
  props: {
    label: { default: "" },
    placeholder: { default: "" },
    modelValue: { default: "" },
    disabled: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    id: { default: "" },
    helperText: { default: "" },
    classes: { default: () => ({}) },
    showToolPanel: { type: Boolean, default: !1 },
    panelPlacement: { default: "down" },
    toolTipIcon: { default: "information-circle-icon" },
    showToolTipIcon: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "onTooltipClick"],
  setup(e, { emit: i }) {
    const l = e, d = P({
      get: () => l.modelValue,
      set: (f) => i("update:modelValue", f)
    }), a = q(), r = P(() => l.success && !l.disabled ? "textArea-success-label" : l.error && !l.disabled ? "textArea-error-label" : "textArea-default-label"), c = P(() => l.success && !l.disabled ? "textArea-success-input" : l.error && !l.disabled ? "textArea-error-input" : "textArea-default-input"), b = P(() => l.success && !l.disabled ? "success-msg" : l.error && !l.disabled ? "error-msg" : "default-msg");
    return (f, v) => {
      var y, h, k, C, g, p, I, T, D, w, E, j, H, J, U, W;
      return t(), n("div", {
        class: o(["relative w-full items-stretch", f.$attrs.class, (y = e.classes) == null ? void 0 : y.container])
      }, [
        e.label && !((h = s(a)) != null && h.inputLabel) ? (t(), n("label", {
          key: 0,
          for: e.id,
          class: o([s(r), "label", (k = e.classes) == null ? void 0 : k.label])
        }, [
          Z(x(e.label) + " ", 1),
          e.showToolTipIcon && !((C = s(a)) != null && C.tooltip) ? (t(), S(s(V), {
            key: 0,
            name: e.toolTipIcon,
            size: "15",
            class: o(["ml-1 cursor-pointer w-[15px]", ((g = e.classes) == null ? void 0 : g.tooltipIcon) || ""]),
            onClick: v[0] || (v[0] = N((Q) => i("onTooltipClick"), ["stop"]))
          }, null, 8, ["name", "class"])) : u("", !0),
          e.showToolTipIcon && ((p = s(a)) != null && p.tooltip) ? $(f.$slots, "tooltip", { key: 1 }, void 0, !0) : u("", !0)
        ], 10, ns)) : u("", !0),
        (I = s(a)) != null && I.inputLabel ? (t(), n("label", {
          key: 1,
          for: e.id
        }, [
          $(f.$slots, "inputLabel", {}, void 0, !0)
        ], 8, os)) : u("", !0),
        m("div", ds, [
          e.showToolPanel && e.panelPlacement === "up" && ((T = s(a)) != null && T.panel) ? (t(), n("div", {
            key: 0,
            class: o([s(c), "textArea-panel rounded-t-lg !border-b-0", (D = e.classes) == null ? void 0 : D.panel])
          }, [
            $(f.$slots, "panel", {}, void 0, !0)
          ], 2)) : u("", !0),
          ve(m("textarea", de({
            id: e.id,
            "onUpdate:modelValue": v[1] || (v[1] = (Q) => ye(d) ? d.value = Q : null),
            "aria-multiline": "true",
            "aria-placeholder": e.placeholder || "TextArea Placeholder",
            "aria-labelledby": e.label || "TextArea Label",
            disabled: e.disabled,
            class: [
              s(c),
              "cursor-pointer",
              e.panelPlacement === "down" && e.showToolPanel ? "rounded-t-lg" : e.panelPlacement === "up" && e.showToolPanel ? "rounded-b-lg" : "rounded-lg",
              e.disabled && (((w = e.classes) == null ? void 0 : w.disabled) || "disabled-textArea"),
              (E = e.classes) == null ? void 0 : E.textAreaInput
            ],
            placeholder: e.placeholder
          }, { ...f.$attrs, class: "", style: {} }), null, 16, is), [
            [Ue, s(d)]
          ]),
          e.showToolPanel && e.panelPlacement === "down" && ((j = s(a)) != null && j.panel) ? (t(), n("div", {
            key: 1,
            class: o([s(c), "textArea-panel rounded-b-lg !border-t-0", (H = e.classes) == null ? void 0 : H.panel])
          }, [
            $(f.$slots, "panel", {}, void 0, !0)
          ], 2)) : u("", !0)
        ]),
        e.helperText && !((J = s(a)) != null && J.inputHelperText) ? (t(), n("p", {
          key: 2,
          class: o(["text-xs font-normal mt-1", s(b), (U = e.classes) == null ? void 0 : U.helperText])
        }, x(e.helperText), 3)) : u("", !0),
        (W = s(a)) != null && W.inputHelperText ? (t(), n("p", {
          key: 3,
          class: o(["text-xs font-normal mt-1", s(b)])
        }, [
          $(f.$slots, "inputHelperText", {}, void 0, !0)
        ], 2)) : u("", !0)
      ], 2);
    };
  }
});
const kn = /* @__PURE__ */ A(cs, [["__scopeId", "data-v-49684ef6"]]), us = ["id"], rs = /* @__PURE__ */ z({
  __name: "Toast",
  props: {
    open: { type: Boolean, default: !1 },
    id: { default: "" },
    variant: { default: "default" },
    placement: { default: "top-left" },
    size: { default: "small" },
    border: { type: Boolean, default: !0 },
    shadow: { type: Boolean, default: !0 },
    classes: { default: () => ({}) }
  },
  setup(e) {
    return (i, l) => {
      var d;
      return t(), n("div", {
        id: e.id,
        class: o([
          "toast-container",
          `toast-${e.placement}`,
          `toast-size-${e.size}`,
          `toast-${e.variant}`,
          { "!hidden": !e.open, border: e.border, "shadow-sm": e.shadow },
          (d = e.classes) == null ? void 0 : d.container
        ]),
        role: "alert"
      }, [
        $(i.$slots, "default", {}, void 0, !0)
      ], 10, us);
    };
  }
});
const wn = /* @__PURE__ */ A(rs, [["__scopeId", "data-v-cc5aba40"]]), fs = {
  key: 0,
  class: "flex items-center cursor-pointer"
}, vs = ["disabled"], bs = {
  key: 0,
  class: "font-body text-base text-app-gray-600 dark:text-app-text-dark-400"
}, ms = { key: 0 }, ys = { key: 1 }, hs = ["disabled"], gs = /* @__PURE__ */ z({
  __name: "Toggle",
  props: {
    modelValue: { type: Boolean, default: !1 },
    size: { default: "large" },
    labelEnabled: { default: "" },
    labelDisabled: { default: "" },
    showLabel: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: i }) {
    const l = e, d = P({
      get() {
        return l.modelValue;
      },
      set(a) {
        i("update:modelValue", a);
      }
    });
    return (a, r) => e.size === "small" ? (t(), n("div", fs, [
      m("label", {
        class: o(["switch rounded-full cursor-pointer", [s(d) ? "bg-app-primary-500" : "bg-app-gray-400", { "mr-2": e.showLabel, "!cursor-not-allowed !bg-app-gray-200": e.disabled }]])
      }, [
        ve(m("input", {
          "onUpdate:modelValue": r[0] || (r[0] = (c) => ye(d) ? d.value = c : null),
          disabled: e.disabled,
          type: "checkbox",
          class: "sr-only peer"
        }, null, 8, vs), [
          [Ee, s(d)]
        ]),
        m("div", {
          class: o(["knob w-3 h-3 bg-white rounded-full", { "float-right": s(d) }])
        }, null, 2)
      ], 2),
      e.showLabel ? (t(), n("div", bs, [
        s(d) ? (t(), n("span", ms, x(e.labelEnabled || "Enabled"), 1)) : (t(), n("span", ys, x(e.labelDisabled || "Disabled"), 1))
      ])) : u("", !0)
    ])) : (t(), n("label", {
      key: 1,
      class: o(["toggle cursor-pointer", [`${e.size}`, { "!cursor-not-allowed": e.disabled }]]),
      style: { width: "300px" }
    }, [
      ve(m("input", {
        "onUpdate:modelValue": r[1] || (r[1] = (c) => ye(d) ? d.value = c : null),
        disabled: e.disabled,
        type: "checkbox",
        class: "sr-only peer"
      }, null, 8, hs), [
        [Ee, s(d)]
      ]),
      m("div", {
        class: o(["toggle-tab", s(d) ? "selected" : "unselected"])
      }, x(e.labelEnabled || "Select"), 3),
      m("div", {
        class: o(["toggle-tab", s(d) ? "unselected" : "selected"])
      }, x(e.labelDisabled || "Unselect"), 3)
    ], 2));
  }
});
const xs = /* @__PURE__ */ A(gs, [["__scopeId", "data-v-e10ced1a"]]), ks = ["id"], ws = {
  key: 0,
  class: "absolute bottom-0 translate-y-8 bg-app-white text-app-gray-900 rounded-lg text-sm font-medium px-3 py-1 shadow-sm dark:bg-app-gray-900 dark:text-app-white"
}, $n = /* @__PURE__ */ z({
  __name: "Tooltip",
  props: {
    text: { default: "" },
    id: { default: "" }
  },
  setup(e) {
    const i = M(!1), l = () => {
      i.value = !0;
    }, d = () => {
      i.value = !1;
    };
    return (a, r) => (t(), n("div", {
      id: e.id,
      role: "tooltip",
      class: "relative flex items-center",
      onMouseenter: l,
      onMouseout: d,
      onBlur: d,
      onFocus: l
    }, [
      i.value && e.text ? (t(), n("div", ws, x(e.text), 1)) : u("", !0),
      $(a.$slots, "default")
    ], 40, ks));
  }
}), qe = Symbol.for("torusui:display"), $s = {
  thresholds: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
    xxl: 2560
  }
};
function Ne(e) {
  return Ie && !e ? window.innerWidth : 0;
}
function Oe(e) {
  return Ie && !e ? window.innerHeight : 0;
}
function pn(e = $s) {
  return { install: (l) => {
    const d = (r) => {
      const { thresholds: c } = e, b = M(Oe(r)), f = Ye({}), v = M(Ne(r));
      function y() {
        b.value = Oe(), v.value = Ne();
      }
      return r && _e(() => y()), el(() => {
        const h = v.value < c.sm, k = v.value < c.md && !h, C = v.value < c.lg && !(k || h), g = v.value < c.xl && !(C || k || h), p = v.value < c.xxl && !(g || C || k || h), I = v.value >= c.xxl;
        f.xs = h, f.sm = k, f.md = C, f.lg = g, f.xl = p, f.xxl = I, f.smAndUp = !h, f.mdAndUp = !(h || k), f.lgAndUp = !(h || k || C), f.xlAndUp = !(h || k || C || g), f.smAndDown = !(C || g || p || I), f.mdAndDown = !(g || p || I), f.lgAndDown = !(p || I), f.xlAndDown = !I, f.height = b.value, f.width = v.value;
      }), Ie && window.addEventListener("resize", y, { passive: !0 }), ll(f);
    }, { mount: a } = l;
    l.mount = (r, c, b) => {
      l.provide(qe, d(c));
      const f = a(r, c, b);
      return l.mount = a, f;
    };
  } };
}
function Cn() {
  const e = je(qe);
  if (!e)
    throw new Error("Could not find display injection");
  return e;
}
const ps = { class: "pb-4" }, Cs = { class: "am-header" }, Is = { class: "am-list" }, Bs = { class: "flex items-center" }, Ts = { class: "am-icon-container" }, Ls = { class: "font-body text-xs text-app-text-500 dark:text-app-text-dark-500" }, Ss = { class: "ml-auto flex" }, zs = {
  key: 0,
  class: "font-body text-xs text-app-text-500 dark:text-app-text-dark-500"
}, Ps = { class: "am-note" }, Ds = /* @__PURE__ */ z({
  __name: "AccountManagement",
  props: {
    accounts: null,
    textTitle: { default: "Accounts" },
    textNote: { default: "Note: The selected default account shall be the account displayed when you sign in on a DApp." },
    textDefault: { default: "Default" },
    textSwitch: { default: "Switch this to Default" }
  },
  emits: ["onSetDefault"],
  setup(e, { emit: i }) {
    const l = (d) => {
      i("onSetDefault", d);
    };
    return (d, a) => (t(), n("div", ps, [
      m("div", Cs, x(e.textTitle), 1),
      m("ul", Is, [
        (t(!0), n(te, null, ae(e.accounts, (r) => (t(), n("li", {
          key: r.id,
          class: "flex items-center py-3 px-4"
        }, [
          m("div", Bs, [
            m("div", Ts, [
              (t(), S(he(r.icon), {
                class: "w-3 h-3 text-app-text-500",
                "aria-hidden": "true"
              }))
            ]),
            m("div", Ls, x(r.id), 1)
          ]),
          m("div", Ss, [
            r.isDefault ? (t(), n("div", zs, x(e.textDefault), 1)) : (t(), S(s(le), {
              key: 1,
              variant: "text",
              onClick: (c) => l(r)
            }, {
              default: O(() => [
                Z(x(e.textSwitch), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          ])
        ]))), 128))
      ]),
      m("div", Ps, x(e.textNote), 1)
    ]));
  }
});
const In = /* @__PURE__ */ A(Ds, [["__scopeId", "data-v-d92df70b"]]), Vs = { class: "pb-4" }, As = { class: "cr-description" }, Ms = { class: "flex items-center" }, Fs = /* @__PURE__ */ z({
  __name: "CrashReporting",
  props: {
    modelValue: { type: Boolean, default: !1 },
    size: { default: "medium" },
    textDescription: { default: "Torus collects anonymous data about any crashes that occur to help improve our products and services." },
    textEnabled: { default: "Crash report was enabled" },
    textDisabled: { default: "Crash report was disabled" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: i }) {
    const d = M(e.modelValue), a = P({
      get: () => d.value,
      set: (r) => {
        d.value = r, i("update:modelValue", r);
      }
    });
    return (r, c) => (t(), n("div", Vs, [
      m("div", As, x(e.textDescription), 1),
      m("div", Ms, [
        R(s(xs), {
          modelValue: s(a),
          "onUpdate:modelValue": c[0] || (c[0] = (b) => ye(a) ? a.value = b : null),
          size: "small",
          "label-enabled": e.textEnabled,
          "label-disabled": e.textDisabled
        }, null, 8, ["modelValue", "label-enabled", "label-disabled"])
      ])
    ]));
  }
});
const Bn = /* @__PURE__ */ A(Fs, [["__scopeId", "data-v-ef152053"]]), Es = { class: "pb-4" }, Ns = { class: "display-label" }, Os = { class: "grid grid-cols-2 space-x-3" }, js = /* @__PURE__ */ z({
  __name: "Display",
  props: {
    isDarkMode: { type: Boolean },
    textTitle: { default: "Select a theme" },
    textLight: { default: "Light" },
    textDark: { default: "Dark" }
  },
  emits: ["onSetDarkMode"],
  setup(e, { emit: i }) {
    const l = (d) => {
      i("onSetDarkMode", d);
    };
    return (d, a) => (t(), n("div", Es, [
      m("div", Ns, x(e.textTitle), 1),
      m("div", Os, [
        m("div", null, [
          R(s(le), {
            variant: e.isDarkMode ? "tertiary" : "primary",
            block: !0,
            onClick: a[0] || (a[0] = (r) => l(!1))
          }, {
            default: O(() => [
              Z(x(e.textLight), 1)
            ]),
            _: 1
          }, 8, ["variant"])
        ]),
        m("div", null, [
          R(s(le), {
            variant: e.isDarkMode ? "primary" : "tertiary",
            block: !0,
            onClick: a[1] || (a[1] = (r) => l(!0))
          }, {
            default: O(() => [
              Z(x(e.textDark), 1)
            ]),
            _: 1
          }, 8, ["variant"])
        ])
      ])
    ]));
  }
});
const Tn = /* @__PURE__ */ A(js, [["__scopeId", "data-v-0c30133e"]]);
export {
  Hs as Accordion,
  In as AccountManagement,
  Ws as Alerts,
  Zs as Avatar,
  gl as Badge,
  qs as Breadcrumb,
  le as Button,
  Js as Card,
  Xs as Carousel,
  Bl as CarouselItem,
  We as Checkbox,
  Qs as CheckboxGroup,
  Ys as ComboBox,
  _s as CopyButton,
  Bn as CrashReporting,
  en as Dialog,
  Tn as Display,
  ln as Divider,
  tn as Drawer,
  an as Dropdown,
  sn as ExpansionPanel,
  nn as Fileuploader,
  V as Icon,
  on as ListGroup,
  dn as Loader,
  cn as LoginForm,
  un as Modal,
  rn as Navbar,
  fn as Pagination,
  vn as ProgressBar,
  Oa as Radio,
  bn as RadioGroup,
  mn as Select,
  yn as Spinner,
  hn as Tab,
  gn as Tabs,
  xn as Tag,
  kn as TextArea,
  Ce as TextField,
  wn as Toast,
  xs as Toggle,
  $n as Tooltip,
  pn as createDisplay,
  Gs as createIcons,
  Ks as getIconName,
  Cn as useDisplay,
  tl as useIcons
};
